import apiUrl from '../../../../constants'
import commonFunction from '../../../../commonFunction'
import constantVariable from '../../../../constantVariable'
import Vue from 'vue'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator,
  withValidation
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import DatePicker from 'vue2-datepicker';
import FileUpload from 'v-file-upload';

import moment from 'moment'
import JQuery from 'jquery'
let $ = JQuery
import { AES, enc } from 'crypto-js';


import authFunction from '../../../../authFunction';

import {
  BasicSelect
} from 'vue-search-select'

Vue.use(FileUpload);
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import {
  FileUploadService
} from 'v-file-upload';

Vue.filter('displayDateFormat', function (value) {

  if (value) {
    return moment(String(value)).format('DD-MM-YYYY hh:mm:ss')
  }

});

Vue.filter('displayDateAMPMFormat', function (value) {

  // if (value) {
  //   return moment(String(value)).format('DD-MM-YYYY hh:mm:ss A')
  // }
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY HH:mm:ss')
  }

});

export default {
  name: 'bulkshipment',
  components: {
    BasicSelect,
    Paginate,
    Loading,
    DatePicker
  },
  props: [],
  data() {
    return {
      //#bulk b2b_alternate_instruction - Delivery /Pickup Start
      reattemptTimeSlotWithDate:'',        
      contactNumber:'',
      pickupAddress:'',
      PickupTimeSlotWithDate:'', 
     //#bulk b2b_alternate_instruction - Delivery /Pickup  End

//  // selectB2CHeavyShippingID  selectAllB2CHeavyShippingID 
    // B2CHeavy obj  OtherShipmentShippingIDCheckedArr allSelected B2CHeavyArr  B2CHeavyShipmentData
  
    B2CHeavy: {
      B2CHeavyShipmentData: [],
      OtherShipmentShippingIDCheckedArr: [],
      allSelected: false,
      checkAllSelected: false,
      B2CHeavyArrCnt: "",
      B2CHeavyArr: [],
    },
      B2CHeavyArr:[],
      MPSGroupIdwithPartialRTOAllowedmodal:false,
      rdoB2CDivDisplay: true, // rtoh
      rdoB2C: 'B2CEcom',
      multipleValues: 0,
      messageBulk: 'raise_ticket_tab',
      page: 'b2bbulkshipment',
      searchListDiv: false,
      displayShippingDiv: true,
      displayFileUploadDiv: false,
      txtShippingIDs: '',
      userTypeForTicket: '',
      ARRANGED_ASSIGN_OPS_TEAM: 11,
      ADDRESS_UPDATED: 8,
      ASSIGNED_OPS_TEAM: 12,
      STATUS_CHANGED: 15,
      UPDATE_CONTACT_DETAILS: 17,
      UPDATE_EMAIL_ADDRESS: 97,
      UPDATE_ALTERNATE_CONTACT_NO: 98,
      CONTACT_DETAILS_UPDATED: 19,
      ASSIGNED_CS_TEAM: 14,
      ADDRESS_CHANGE: 9,
      FAKE_NDR: 133,
      REFUSED_DOORSTEP_DELIVERY: 136,
      DELAY_IN_PICKUP_SUB_REASON: 131,
      FAKE_NPR: 119,
      FAKE_PICKUP: 120,
      DENIED_PICKUP: 121,
      PAYMENT_DETAILS_CHANGE_REQUESTED: 45,
      CHANGE_REATTEMPT_DATE: 80,
      ATTEMPT_DELIVERY: 58,
      REATTEMPT_DATE_CHANGED: 40,
      // #bulk b2b_alternate_instruction - Delivery/Pickup  Start 
      Alternate_Instruction_Delivery: constantVariable.Alternate_Instruction_Delivery,
      Reattempt_Time_Slot_Delivery: constantVariable.Reattempt_Time_Slot_Delivery,
      Attempt_Delivery: constantVariable.Attempt_Delivery,
      Contact_Updated :constantVariable.Contact_Updated,
      Updated_Contact: constantVariable.Updated_Contact,
      Escalation_For_Delivery: constantVariable.Escalation_For_Delivery,
     
      Alternate_Instruction_Pickup: constantVariable.Alternate_Instruction_Pickup,
      Reattempt_Time_Slot_Pickup: constantVariable.Reattempt_Time_Slot_Pickup,
      Attempt_Pickup: constantVariable.Attempt_Pickup,
      Hold_Pickup: constantVariable.Hold_Pickup,
      Escalation_For_Pickup: constantVariable.Escalation_For_Pickup,
      Pickup_Details_Updates: constantVariable.Pickup_Details_Updates,
      Address_Updated: constantVariable.Address_Updated,
      Special_Instruction_Pickup: constantVariable.Special_Instruction_Pickup,

      INFORMATION_GIVEN: constantVariable.INFORMATION_GIVEN,
      // #bulk b2b_alternate_instruction - Delivery/Pickup  End

      escalation: 0,
      fakeNdrStatus: 0,
      selected_action: 'edit_bulk_tickets',
      userRole: '',
      ticket: {
        disabled: false
      },
      subDepartmentList: [],
      arrDisplaySubTypes: [{
          'name': 'forward',
          'subtypes': [{
              'id': constantVariable.FUTURE_DELIVERY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SELF_COLLECT,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.URGENT_DELIVERY,
              'types': [{
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.HOLD_SUB_REASON,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.LATE_DELIVERY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.PRICE_ISSUE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.PRODUCT_ISSUE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.DUPLICATE_ORDER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.FAKE_ORDER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.ODA_LOCATION,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.PURCHASED_FROM_OTHER_SOURCE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.MIND_CHANGE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.CUSTOMER_OUT_OF_STATION,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.CUSTOMER_WANT_OPEN_DELIVERY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.DUE_TO_FAKE_UPDATE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.NEVER_ORDERED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.COD_NOT_AVAILABLE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SR_DEMAND_FOR_EXTRA_AMOUNT,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.ORDERED_BY_MISTAKE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.NO_SUCH_REASON,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.NOT_INTERESTED_TO_TAKE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SR_MISBEHAVIOUR,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.INCORRECT_PINCODE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.CUSTOMER_SHIFTED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SOMEONE_ELSE_ORDERED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.FORGOT_TO_APPLY_PROMOCODE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.REFUND_PENDING_OF_PREVIOUS_ORDER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.DEMISE_IN_FAMILY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            }
          ]
        },
        {
          'name': 'reverse',
          'subtypes': [{
              'id': constantVariable.FUTURE_PICKUP,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.PICKUP_WITHOUT_QC,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.EXCEPTIONAL_PICKUP,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.HOLD_SUB_REASON,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.QC_FAILED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.AS_PER_CLIENT,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.PRODUCT_USED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.PRODUCT_HANDEDOVER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.OUT_SERVICE_AREA,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.DUPLICATE_REQUEST,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.RETURN_REASON_MISMATCH,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            }
          ]
        }
      ],
      frmFilterTicket: true,
      isLoading: false,
      isModelLoading: false,
      RaiseTicketDiv: false,
      searchBatchDiv: true,
      ticketId: '',
      file: '',
      files: '',
      excelFileUploadPath: '',
      source: [],
      sourceId: '',
      selectedSourceObj: {
        value: '',
        text: ''
      },
      ticketType: [],
      ticketTypeId: '',
      selectedTicketObj: {
        value: '',
        text: ''
      },
      reason: [],
      reasonId: '',
      selectedReasonObj: {
        value: '',
        text: ''
      },
      subReason: [],
      subReasonId: '',
      selectedSubReasonObj: {
        value: '',
        text: ''
      },
      action: [],
      actionId: '',
      selectedActionObj: {
        value: '',
        text: ''
      },
      ticketStatus: [{
        "value": 1,
        "text": "Open"
      }, {
        "value": 2,
        "text": "Follow Up"
      }, {
        "value": 3,
        "text": "Closed"
      }],
      ticketStatusId: '',
      selectedTicketStatusObj: {
        value: '',
        text: ''
      },
      searchOptions: [],
      searchId: '',
      selectedSearchObj: {
        value: '',
        text: ''
      },

       //#bulk b2b_alternate_instruction - Pickup Strat
       PickupAddress: {
        Name: '',
        Address: '',
        City: '',
        State: '',
        Pincode: '',
        PhoneNo: '',
        PhoneNoDisplay: '',
        PhoneNoAlt: '',
        PhoneNoAltDisplay: ''
      },
      //#bulk b2b_alternate_instruction - Pickup End

      reAttemptDate: '',
      startDate: new Date(),
      endDate: new Date(),
      searchDate: new Date(),
      batches: [],
      validated: false,
      shortcuts: [{
        text: 'Today',
        startDate: new Date()

      }],
      format: 'DD-MM-YYYY',
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      SMSShipmentData: [],
      address: '',
      location: '',
      pincode: '',
      orderType: [{
          value: 'CashOnDelivery',
          text: 'CashOnDelivery'
        },
        {
          value: 'PrePaid',
          text: 'PrePaid'
        }
      ],
      orderTypeId: '',
      selectedOrderTypeObj: {
        value: '',
        text: ''
      },
      netPayment: '',
      comments: '',
      businessFlowId: 'Forward',
      businessFlow: [{
          value: '1',
          text: 'Forward'
        }, //#bulk_appointment
        {
          value: '2',
          text: 'Forward (Appointment Date)'
        }
      ],
      selectedBusinessFlowObj: {
        value: 'Forward',
        text: 'Forward'
      },
      TicketDiv: true,
      BatchListDiv: false,
      SendSMS: {
        SMSSuccessful: false,
        SendSMSDiv: false,
        submitted: false,
        SendSMSModal: false,
        ActualSMSCode: "",
        SendSMSArr: [],
        PhoneNo: "",
        PhoneNoDisplay: "",
        ClientID: "",
        ClientName: "",
        ShippingID: "",
        Message: "",
        SelectedSendSMSObj: {
          value: '',
          text: ''
        },
        SMSData: [],
        SendSMSKey: "xbsndvT",
        ReasonArr: [],
        Reason: "",
        SelectedReasonObj: {
          value: '',
          text: ''
        },
        SMSShipmentData: [],
        OtherShipmentShippingIDCheckedArr: [],
        allSelected: false,
        checkAllSelected: true,
        OtherShipmentLogCnt: "",
        OtherShipmentLogArr: [],
      },
      fromDate: '',
      toDate: '',
      tillDate1: '',
      tillDate2: '',
      pageCount: 0,
      pageNo: 0,
      isLoading: false,
      perPage: 50,
      resultCount: '',
      showList: 0,
      listTotalCount: 0,
      offset: '',
      limit: '',
      selectAllRecord: false,
      shipmentTickets: [],
      shipmentSearchedTickets: [],
      ticketShipmentData: [],
      ticketIDS: [],
      fullPage: false,
      currentSelectedTab: 'edit_bulk_tickets',
      Ticketmodal: false,
      SummaryOptionObj: [],
      SummarySelectOptionObj: {
        value: '',
        text: ''
      },
      DashboardArr: [],
      ticketTypeSelect: true,
      reasonSelect: true,
      subReasonSelect: true,
      actionSelect: true,
      ticketStatusSelect: true,
      ticketResultMsg: '',
      ticketResultModal: false,
      objTicketSearch: {},
      editHoldTicket: false,
      alternateContactNo: '',
      updateTicketButton: false,
      updateTicketButtoncheck: false,
      closedUnSelectedAll: true,
      isLoadingPagination: false,
      usertype: '',
      enableReattemptDate: false,
      activeSubDepartmentName: '',
      filter: [],
      enters: 0,
      btnReset: false,
      searchDisable: false,
      payMethods: [{
          text: 'COD',
          value: 1
        },
        {
          text: 'Prepaid',
          value: 2
        }
      ],
      selectedMethodObj: {
        value: '',
        text: ''
      },
      methodId: '',
      disPayment: false,
      disPaymentMethod: false,
      confirmationModal: false,
      messageis: '',
      OldDeliveryUserOrUserId: '',
      //#bulk_appointment limit message change 
      bulkShippingIDsMessage:'NOTE:  '+constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT+' AWB IDs are allowed to be processed at once.', 
      //bulkShippingIDsMessage: 'NOTE: For B2C Ecom - only 4000 AWB IDs are allowed to be processed at once.',
      bulkLimitShippingIDsMessage : 'NOTE:  '+constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT+' AWB IDs are allowed to be processed at once.',
      appoinmentDateMessage : 'NOTE:  '+constantVariable.APPOINMENT_DATE_B2BBULK_LIMIT+' AWB IDs are allowed to be processed at once.',
      // #bulk_appointment 
      Change_Appointment_Date: constantVariable.Change_Appointment_Date,
      AppointmentDeliveryDate:'',
      fromAppointmentDeliveryTimeValidate: new Date(),
    }
  },
  created: function () {
    // this.getActiveSubDepartment();
  },
  computed: {
    //#bulk_appointment to Appoinment Delivery date 
    toAppointmentDeliveryTimeValidate() {
      const date = new Date();
      date.setMonth(date.getMonth() + 1);
      return date;
    },

     // #bulk b2b_alternate_instruction - Delivery/Pickup  Start
    dynamicTimeSlotLabel() {
      if (this.selectedReasonObj.value === constantVariable.Alternate_Instruction_Pickup && this.selectedSubReasonObj.value === constantVariable.Hold_Pickup) {
        return 'Pickup Hold Till Date';   
      }
       else if (this.selectedReasonObj.value === constantVariable.Alternate_Instruction_Delivery) {

        return 'Reattempt Delivery Time Slot With Date';
      }  
      return 'Reattempt Pickup Time Slot With Date';
    },
    minSelectableDateTime() {
        // Today with current time
        return new Date();
    },
    maxSelectableDateTime() {
        // 30 days from now, end of day
        const end = new Date();
        end.setDate(end.getDate() + 30);
        end.setHours(23, 59, 59, 999);
        return end;
    },
    // #bulk b2b_alternate_instruction - Delivery/Pickup End 

  },

  mounted() {
    [this.subDepartmentList, this.DepartmentID, this.userdetail, this.permissiondata, this.userTypeForTicket, this.SummarySelectOptionObj, this.SummaryOptionObj] = commonFunction.getuserDetailsAndpermissionData();
    this.accessRestrictor();
    this.userid = this.userdetail[0].userid;
    this.username = this.userdetail[0].username;
    this.userRole = this.userdetail[0].roles[0].rolename;
    this.OldDeliveryUserOrUserId = this.userdetail[0].OldDeliveryUserOrUserId;
    this.searchListDiv = false;
    if (this.$route.params.message) {
      this.searchListDiv = true;
    }

  },

  methods: {
    // #bulk_appointment YYYY-MM-DD convert method
    dateFormatYYYYMMDD(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
    // trigger: function () {
    //   this.OnFilterClick();
    // },

    onChange: function () {

      if (this.fromDate != null && this.toDate != null) {
        if (this.fromDate != '') {
          let dateDisabled = new Date(this.fromDate);
          this.tillDate1 = new Date();
          dateDisabled.setDate(this.fromDate.getDate() + 30);
          this.tillDate1 = dateDisabled;
        }
        if (this.toDate != '') {
          let dateDisabled2 = new Date(this.toDate);
          this.tillDate2 = new Date();
          dateDisabled2.setDate(this.toDate.getDate() - 30);
          this.tillDate2 = dateDisabled2;
        }
      } else {
        this.fromDate = '';
        this.toDate = '';
        this.tillDate1 = '';
        this.tillDate2 = '';
      }

    },

    formatShipments() {

      this.txtShippingIDs = this.txtShippingIDs.replace(/(\r\n|\n|\r|\s)/gm, ",");
      this.txtShippingIDs = this.txtShippingIDs.split(/[\s,]+/).join();

      //vishvas : comment due to error : this.filter.trim() error
    
      // if(this.filter){
      //   console.log("Inside this")
      //   this.filter = this.filter.trim();
      //   this.filter = this.filter.replace(/(\r\n|\n|\r|\s)/gm, ",");
      //   this.filter = this.filter.split(/[\s,]+/).join();
      // }
      // console.log("this.filter after all:",this.filter)

    },

    downalodBatchReport(batchId) {
      try {
        let token = 'edw3r323432472748923';
        this.input = ({
          'batch_id': batchId
        });
        this.isLoading = true;
        var URL = '';
        if (this.selected_action == 'raise_ticket_tab') {
          URL = apiUrl.api_url + 'createB2BBatchReportSQS'
        } else {
          URL = apiUrl.api_url + 'createBatchReport'
        }
        axios({
          // url: apiUrl.api_url + 'createBatchReport',
          // url: apiUrl.api_url + 'createBatchReportsqs',
          url: URL,
          method: 'POST',
          data: this.input,
          responseType: 'blob', // important
          headers: commonFunction.getusertoken(),
        }).then((response) => {
          this.isLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'B2BBulkBatchListReport.xlsx');
          document.body.appendChild(link);
          link.click();
        });
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - downalodBatchReport";
        this.$alertify.error(msg);
      }
    },

    accessRestrictor() {
      var desider = 0;
      var n = window.location.href.search('#');
      var link = window.location.href.substr(n + 1);
      var linkToo = window.location.href.substr(n + 2);
      for (let i = 0; i < this.permissiondata.length; i++) {
        if (link == this.permissiondata[i].url) {
          desider++;
        }
      }
      if (desider == 0) {
        this.$router.push('/dashboard');
        this.$alertify.error("Access Denied for " + linkToo + " Module.");
      }
    },

    handleFileUpload() {
      try {
        this.isLoading = true;
        this.file = this.$refs.file.files[0];

        if (['xls', 'xlsx'].indexOf(this.file.name.split('.')[this.file.name.split('.').length - 1]) === -1) {
          this.$alertify.error('Please upload file with .xls, .xlsx extensions.');
          document.getElementById('file').value = '';

        }
        this.isLoading = false;

      } catch (error) {
        this.isLoading = false;
        let msg = error + " - handleFileUpload";
        this.$alertify.error(msg);
      }
    },

    submitFile() {
      try {
        if (document.getElementById('file').value == '') {
          this.$alertify.error('Please upload file with .xls, .xlsx extensions.');
          return false;
        }
        let token = 'edw3r323432472748923';
        let formData = new FormData();

        formData.append('file', this.file);
        formData.append('businessflow', this.selectedBusinessFlowObj.text);
        this.isLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'uploadExcel',
          'data': formData,
          'headers': commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
          if (result.data.data.status == true) {

            this.excelFileUploadPath = result.data.data.data;
            this.$alertify.success(result.data.data.msg);
            this.ShowRaiseTicketDiv('address_change');

          } else {
            this.ticketResultMsg = '';
            this.ticketResultMsg = result.data.data.msg;
            this.ticketResultModal = true;
          }

        }, error => {
          this.isLoading = false;
          var commonVariable = commonFunction.showNetworkError(error);
          this.$alertify.error(commonVariable);
        })
        return false;
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - submitFile";
        this.$alertify.error(msg);
      }
    },

    downloadExcelFormat() {
      try {
        let token = 'edw3r323432472748923';

        this.input = ({
          'businessflow': this.selectedBusinessFlowObj.text
        });
        this.isLoading = true;
        axios({
          url: apiUrl.api_url + 'downloadExcel',
          method: 'POST',
          data: this.input,
          responseType: 'blob', // important
          headers: commonFunction.getusertoken(),
        }).then((response) => {
          this.isLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'downloadFormat.xlsx');
          document.body.appendChild(link);
          link.click();
        }, error => {
          var commonVariable = commonFunction.showNetworkError(error);
          this.$alertify.error(commonVariable);
        });
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - downloadExcelFormat";
        this.$alertify.error(msg);
      }
    },

    //Start SendSMS functionality
    displayPhoneNoPattern(PhoneNo) {
      try {
        let PhoneNoDisplay = null;
        if (PhoneNo) {
          PhoneNoDisplay = new Array(PhoneNo.length - 3).join('X') + PhoneNo.substr(PhoneNo.length - 4, 4);
        }
        return PhoneNoDisplay;
      } catch (error) {
        let msg = error + " Something went wrong in Display Phone No Pattern.";
        this.$alertify.error(msg);
      }
    },

    getShippingDataToSendSMS() {
      try {
        let txtShippingIDs = this.txtShippingIDs;
        if (txtShippingIDs != '') {
          txtShippingIDs = txtShippingIDs.trim();
          let ShippingIDsArr = txtShippingIDs.split(',');
          let ArrCnt = ShippingIDsArr.length;
          if (ArrCnt > 50) {
            let msg = "Please select Shipping IDs less than or equal to 50.";
            this.$alertify.error(msg);
            return false;
          }

          this.isLoading = true;
          this.resetSendSMSModalData();

          this.input = ({
            Shipments: ShippingIDsArr
          })
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getShippingDataToSendSMS',
              'data': this.input,
              'headers': commonFunction.getusertoken(),
            })
            .then(result => {
              this.isLoading = false;
              let resultDataCrm = result.data.data;
              if (resultDataCrm.status) {
                let resultData = result.data.data.data;
                if (resultData.ReturnCode === 100) {

                  this.TicketDiv = false;
                  this.SendSMS.SendSMSDiv = true;
                  this.getSMSReason();

                  let OtherShipmentLog = resultData.ShipmentDetails;
                  let OtherShipmentLogCnt = OtherShipmentLog.length;
                  this.SendSMS.OtherShipmentLogCnt = OtherShipmentLogCnt;
                  if (OtherShipmentLogCnt > 0) {
                    this.SendSMS.OtherShipmentLogArr = [];

                    let i;
                    for (i = 0; i < OtherShipmentLogCnt; i++) {
                      OtherShipmentLog[i].ActionStatus = "";
                      OtherShipmentLog[i].CurrentHubName = "";
                      OtherShipmentLog[i].DestinationHubName = "";
                      OtherShipmentLog[i].ClientName = OtherShipmentLog[i].BusinessAccountName;
                      this.SendSMS.OtherShipmentLogArr.push(OtherShipmentLog[i]);

                      // get Hub Detail By Id
                      if (OtherShipmentLog[i].CurrentHubID > 0) {
                        this.getHubDetailById(OtherShipmentLog[i].CurrentHubID, "C", i);
                      }
                      // get Hub Detail By Id
                      if (OtherShipmentLog[i].FinalDestinationID > 0) {
                        this.getHubDetailById(OtherShipmentLog[i].FinalDestinationID, "D", i);
                      }

                      // get ClientName by ID
                      if (OtherShipmentLog[i].ClientID > 0) {
                        //  this.getClientDetailsById(OtherShipmentLog[i].ClientID, i);
                      }

                    }
                  } else {
                    this.SendSMS.OtherShipmentLogArr = [];
                  }

                } else {
                  let msg = resultData.ReturnMessage;
                  this.$alertify.error(msg);
                }
              } else {
                let msg = resultDataCrm.msg;
                this.$alertify.error(msg);
              }
            }, error => {
              this.isLoading = false;
              var commonVariable = commonFunction.showNetworkError(error);
              this.$alertify.error(commonVariable);
            })
        } else {
          this.$alertify.error('Please enter shipping ids.');
          return false;
        }
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - getShippingDataToSendSMS";
        this.$alertify.error(msg);
      }
    },

    getSMSReason() {
      try {
        this.SendSMS.ReasonArr = [];
        if (this.businessFlowId === 'Forward') {
          this.SendSMS.ReasonArr.push({
            'value': 'NORESPONSE_CUSTOMER_INTIMATION',
            'text': 'No Response'
          });
          this.SendSMS.ReasonArr.push({
            'value': 'XB_COLLECT_ORDER',
            'text': 'Self Collect'
          });
        } else if (this.businessFlowId === 'Reverse') {
          this.SendSMS.ReasonArr.push({
            'value': 'NORESPONSE_CUSTOMER_INTIMATION',
            'text': 'No Response'
          });
        }
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - getSMSReason";
        this.$alertify.error(msg);
      }
    },

    selectedSMSReason(SelectedData) {
      try {
        this.SendSMS.SelectedReasonObj.text = SelectedData.text;
        this.SendSMS.SelectedReasonObj.value = SelectedData.value;
        this.SendSMS.Reason = SelectedData.value;
        this.SendSMS.ActualSMSCode = SelectedData.value;
        this.getSMSTextByActualSMSCode();
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - selectedSMSReason";
        this.$alertify.error(msg);
      }

    },

    handleSubmitForSendSMS(e) {
      try {
        this.SendSMS.submitted = true;
        this.$validator.validate().then(valid => {
          if (valid) {

            if (this.SendSMS.Reason === "") {
              let msg = "Please select Reason.";
              this.$alertify.error(msg);
              return false;
            } else if (this.SendSMS.Message === "") {
              let msg = "Please select message.";
              this.$alertify.error(msg);
              return false;
            }

            let ArrCnt = this.SendSMS.SMSShipmentData.length;
            if (ArrCnt === 0) {
              let msg = "Please select Shipping IDs.";
              this.$alertify.error(msg);
              return false;
            }

            let ShipmentStatus;
            let Status;
            let businessFlow;
            let OtherShipmentLogArrIndex;
            if (ArrCnt > 0 && ArrCnt < 51) {
              for (let i = 0; i < ArrCnt; i++) {

                OtherShipmentLogArrIndex = this.SendSMS.SMSShipmentData[i].index;

                this.SendSMS.SMSSuccessful = false;
                this.SendSMS.ShippingID = this.SendSMS.SMSShipmentData[i].shippingData.ShippingID;
                this.SendSMS.PhoneNo = this.SendSMS.SMSShipmentData[i].shippingData.PrimaryPhoneNo;
                this.SendSMS.PhoneNoDisplay = this.displayPhoneNoPattern(this.SendSMS.SMSShipmentData[i].shippingData.PrimaryPhoneNo);
                this.SendSMS.ClientID = this.SendSMS.SMSShipmentData[i].shippingData.ClientID;
                this.SendSMS.ClientName = this.SendSMS.SMSShipmentData[i].shippingData.BusinessAccountName;

                //  start Shipment status logic
                this.SendSMS.OtherShipmentLogArr[OtherShipmentLogArrIndex].ActionStatus = "";
                ShipmentStatus = this.SendSMS.SMSShipmentData[i].shippingData.ShipmentStatus;
                Status = this.SendSMS.SMSShipmentData[i].shippingData.Status;
                businessFlow = this.SendSMS.SMSShipmentData[i].shippingData.BusinessFlow;
                if ((ShipmentStatus !== "Inscan" || ShipmentStatus !== "InScan") && Status !== "Shipped") {
                  this.SendSMS.SMSSuccessful = false;

                  let msg = "Shipment is not in desired status to send SMS.";
                  this.SendSMS.OtherShipmentLogArr[OtherShipmentLogArrIndex].ActionStatus = msg;
                  this.$alertify.error(msg);
                } else if (this.businessFlowId !== businessFlow) {
                  this.SendSMS.SMSSuccessful = false;
                  let msg = "Wrong Business Flow to send SMS.";
                  this.SendSMS.OtherShipmentLogArr[OtherShipmentLogArrIndex].ActionStatus = msg;
                  this.$alertify.error(msg);
                } else {
                  this.sendSMSToNumber(OtherShipmentLogArrIndex);
                }
                //  End Shipment status logic
              }
            } else {
              let msg = "Please select Shipping IDs less than or equal to 50.";
              this.$alertify.error(msg);
              return false;
            }

          } else {
            alert(e);
          }
        });
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - handleSubmitForSendSMS";
        this.$alertify.error(msg);
      }
    },

    sendSMSToNumber(IndexId) {
      try {
        this.SendSMS.SMSData = [];
        this.isLoading = true;
        let Message = this.SendSMS.Message;
        let ActualSMSCode = this.SendSMS.ActualSMSCode;

        if (ActualSMSCode === "XB_COLLECT_ORDER") {
          this.SendSMS.SMSData.push(this.SendSMS.ShippingID);
          this.SendSMS.SMSData.push(this.SendSMS.ShippingID);
        } else if (ActualSMSCode === "NORESPONSE_CUSTOMER_INTIMATION") {
          this.SendSMS.SMSData.push(this.SendSMS.ClientName);
          this.SendSMS.SMSData.push(this.SendSMS.ShippingID);
        }

        this.input = ({
          "MobileNumber": this.SendSMS.PhoneNo,
          "SMSID": this.SendSMS.ActualSMSCode,
          "SMSData": this.SendSMS.SMSData,
          "SendSMSKey": this.SendSMS.SendSMSKey,
          "ClientID": this.SendSMS.ClientID,
        });

        let token = "";
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'sendSMSToNumber',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let resultData = result.data.data.data;
            if (resultData.code === 200) {
              this.SendSMS.SMSSuccessful = true;
              this.SendSMS.OtherShipmentLogArr[IndexId].ActionStatus = "Successful";
              // let msg = resultData.message;
              let msg = this.SendSMS.PhoneNoDisplay + " - Message sent successfully";
              this.$alertify.success(msg);
            } else {
              this.SendSMS.SMSSuccessful = false;
              this.SendSMS.OtherShipmentLogArr[IndexId].ActionStatus = "Fail";
              let msg = resultData.message;
              this.$alertify.error(msg);
            }
          } else {
            this.SendSMS.SMSSuccessful = false;
            this.SendSMS.OtherShipmentLogArr[IndexId].ActionStatus = "Fail";
            let msg = resultDataCrm.msg;
            this.$alertify.error(msg);
          }
        }, error => {
          this.SendSMS.SMSSuccessful = false;
          this.SendSMS.OtherShipmentLogArr[IndexId].ActionStatus = "Fail";
          this.isLoading = false;
          let msg = error;
          this.$alertify.error(msg);
        })
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - sendSMSToNumber";
        this.$alertify.error(msg);
      }
    },

    getSMSTextByActualSMSCode() {
      try {
        this.isLoading = true;
        let ActualSMSCode = this.SendSMS.ActualSMSCode;
        this.SendSMS.SendSMSArr = [];
        this.SendSMS.SelectedSendSMSObj = {
          value: '',
          text: ''
        };

        this.input = ({
          'actualsmscode': ActualSMSCode,
        });
        let token = "";
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getSMSTextByActualSMSCode',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let resultData = result.data.data.data;
            if (resultData.code === 200) {
              if (ActualSMSCode === "NORESPONSE_CUSTOMER_INTIMATION") {
                let SendSMSArrData = resultData.data
                this.SendSMS.SendSMSArr.push({
                  'value': SendSMSArrData,
                  'text': SendSMSArrData
                });

                this.SendSMS.SelectedSendSMSObj = this.SendSMS.SendSMSArr[0];
                this.SendSMS.Message = this.SendSMS.SelectedSendSMSObj.value;
              } else {
                let SendSMSArr = resultData.data;
                let ArrCnt = SendSMSArr.length;
                if (ArrCnt > 0) {
                  for (let i = 0; i < ArrCnt; i++) {
                    this.SendSMS.SendSMSArr.push({
                      'value': SendSMSArr[i].smstext,
                      'text': SendSMSArr[i].smstext
                    });
                  }
                  this.SendSMS.SelectedSendSMSObj = this.SendSMS.SendSMSArr[0];
                  this.SendSMS.Message = this.SendSMS.SelectedSendSMSObj.value;
                }

              }

            } else {
              let msg = resultData.message;
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultDataCrm.msg;
            this.$alertify.error(msg);
          }
        }, error => {
          this.isLoading = false;
          let msg = error;
          this.$alertify.error(msg);
        })
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - getSMSTextByActualSMSCode";
        this.$alertify.error(msg);
      }
    },

    closeSendSMSModal() {
      this.SendSMS.SendSMSModal = false;
    },

    closeBModalCommonFunction(string) {
      var tempvariable;
      [this.filter, this.Ticketmodal, tempvariable, tempvariable, tempvariable, tempvariable, this.MPSGroupIdwithPartialRTOAllowedmodal, tempvariable, this.ticketResultModal, string] = commonFunction.closeBModalCommonFunction(string);

      if (this.currentSelectedTab == 'edit_bulk_tickets') {
        this.assignValuesToObject();
      }
    },

    assignValuesToObject() {
      this.source = this.objTicketSearch.source;
      this.ticketType = this.objTicketSearch.ticketType;
      this.reason = this.objTicketSearch.reason;
      this.reasonId = this.objTicketSearch.reasonId;
      this.selectedReasonObj = this.objTicketSearch.selectedReasonObj;
      this.subReason = this.objTicketSearch.subReason;
      this.subReasonId = this.objTicketSearch.subReasonId;
      this.selectedSubReasonObj = this.objTicketSearch.selectedSubReasonObj;
      this.action = this.objTicketSearch.action;
      this.actionId = this.objTicketSearch.actionid;
      this.selectedActionObj = this.objTicketSearch.selectedActionObj;
      this.ticketStatus = this.objTicketSearch.ticketStatus;
      this.ticketStatusId = this.objTicketSearch.ticketStatusId;
      this.selectedTicketStatusObj = this.objTicketSearch.selectedTicketStatusObj;

    },

    openTicketModal() {
      this.enableReattemptDate = true;
      if (this.ticketIDS.length == 0) {
        this.$alertify.error('Please select ticket.');
        return false;
      }
      this.Ticketmodal = true;
      if (this.currentSelectedTab == 'edit_bulk_tickets') {

        this.objTicketSearch = {
          'source': this.source,
          'ticketType': this.ticketType,
          'reason': this.reason,
          'reasonId': this.reasonId,
          'selectedReasonObj': this.selectedReasonObj,
          'subReason': this.subReason,
          'subReasonId': this.subReasonId,
          'selectedSubReasonObj': this.selectedSubReasonObj,
          'action': this.action,
          'actionid': this.actionId,
          'selectedActionObj': this.selectedActionObj,
          'ticketStatus': this.ticketStatus,
          'ticketStatusId': this.ticketStatusId,
          'selectedTicketStatusObj': this.selectedTicketStatusObj
        };
      }

      this.source = [];
      this.ticketType = [];
      this.reason = [];
      this.subReason = [];

      let enableSubReason = false;
      if (this.SummarySelectOptionObj.text == 'Forward') {

        if (-1 !== this.arrDisplaySubTypes[0].subtypes.findIndex(o => o.id == this.subReasonId)) {
          if (this.subReasonId !== constantVariable.URGENT_DELIVERY) {
            this.getTrackingSubType(this.ticketTypeId, this.SummarySelectOptionObj.text, 'Edit', this.subReasonId);
            enableSubReason = true;
          }
        }

      } else {

        if (-1 !== this.arrDisplaySubTypes[1].subtypes.findIndex(o => o.id == this.subReasonId)) {
          if (this.subReasonId !== constantVariable.URGENT_PICKUP) {
            this.getTrackingSubType(this.ticketTypeId, this.SummarySelectOptionObj.text, 'Edit', this.subReasonId);
            enableSubReason = true;
          }
        }
      }

      if (enableSubReason == true && ((this.SummarySelectOptionObj.text == 'Forward') || (this.SummarySelectOptionObj.text == 'Reverse' && this.subReasonId != constantVariable.URGENT_PICKUP))) {
        this.getTrackingType(this.reasonId, this.SummarySelectOptionObj.text, 'Edit', this.subReasonId);
      }

      this.comments = '';


      if (this.ticketShipmentData.length == 1) {

        if (this.ticketShipmentData[0].shippingData.sourceid) {
          let intSourceIndex = this.objTicketSearch.source.findIndex(o => o.value == this.ticketShipmentData[0].shippingData.sourceid);
          this.selectedSourceObj.text = this.objTicketSearch.source[intSourceIndex].text;
          this.selectedSourceObj.value = this.objTicketSearch.source[intSourceIndex].value;
        } else {
          let intSourceIndex = this.objTicketSearch.source.findIndex(o => o.value == this.shipmentTickets[0].sourceid);
          this.selectedSourceObj.text = this.objTicketSearch.source[intSourceIndex].text;
          this.selectedSourceObj.value = this.objTicketSearch.source[intSourceIndex].value;
        }

        this.reAttemptDate = this.ticketShipmentData[0].shippingData.reattemptdate;
        // console.log( 'reAttemptDate 1 : '+this.reAttemptDate );
        this.address = this.ticketShipmentData[0].shippingData.address;
        this.pincode = this.ticketShipmentData[0].shippingData.pincode;
        this.orderTypeId = this.ticketShipmentData[0].shippingData.ordertype;
        this.netPayment = this.ticketShipmentData[0].shippingData.netpayment;
        this.alternateContactNo = this.ticketShipmentData[0].shippingData.alternatecontactnumber;
        this.emailAddress = this.ticketShipmentData[0].shippingData.emailaddress;
        if (this.subReasonId == 44) {
          var method = {
            value: '',
            text: ''
          };
          if (this.ticketShipmentData[0].shippingData.ordertype == 'PrePaid') {
            method = {
              value: 2,
              text: 'Prepaid'
            };
            this.selectedMethod(method);
          } else {
            method = {
              value: 1,
              text: 'COD'
            };
            this.selectedMethod(method);
          }
        }
        this.disPayment = true;
        this.disPaymentMethod = true;
      } else {
        let intTicketDataLength = this.ticketShipmentData.length;
        let boolIsMultipleSource = false;
        if (intTicketDataLength > 1) {

          if (this.ticketShipmentData[0].shippingData.sourceid) {
            for (let i = 0; i < intTicketDataLength; i++) {

              if (this.ticketShipmentData[0].shippingData.sourceid != this.ticketShipmentData[i].shippingData.sourceid) {
                boolIsMultipleSource = true;
                break;
              }
            }
          } else {
            for (let i = 0; i < this.shipmentTickets.length; i++) {
              if (this.shipmentTickets[0].sourceid != this.shipmentTickets[i].sourceid) {
                boolIsMultipleSource = true;
                break;
              }
            }
          }

          // console.log( 'boolIsMultipleSource : '+boolIsMultipleSource );
          if (true == boolIsMultipleSource) {
            this.selectedSourceObj.text = "Multiple";
            this.selectedSourceObj.value = "Multiple";
          } else {

            if (this.ticketShipmentData[0].shippingData.sourceid) {
              let intSourceIndex = this.objTicketSearch.source.findIndex(o => o.value == this.ticketShipmentData[0].shippingData.sourceid);
              this.selectedSourceObj.text = this.objTicketSearch.source[intSourceIndex].text;
              this.selectedSourceObj.value = this.objTicketSearch.source[intSourceIndex].value;
            } else {
              let intSourceIndex = this.objTicketSearch.source.findIndex(o => o.value == this.shipmentTickets[0].sourceid);
              this.selectedSourceObj.text = this.objTicketSearch.source[intSourceIndex].text;
              this.selectedSourceObj.value = this.objTicketSearch.source[intSourceIndex].value;
            }

          }
        }
      }
      this.selectedTicketStatusObj = {
        text: '',
        value: ''
      };
      this.ticketStatus = [];
      this.ticketStatusId = '';
      this.action = [];
      this.actionId = '';
      this.selectedActionObj = {
        value: '',
        text: ''
      };

      this.getTicketAction(this.subReasonId, 'Edit');
      // console.log( 'reAttemptDate 2 : '+this.reAttemptDate );
    },

    openSendSMSModal() {
      this.resetSendSMSModalData();
      //  this.getSMSTextByActualSMSCode();
      this.getSMSReason();
      this.SendSMS.SendSMSModal = true;
    },

    resetSendSMSModalData() {
      this.SendSMS.OtherShipmentShippingIDCheckedArr = [];
      this.SendSMS.OtherShipmentLogArr = [];
      this.SendSMS.allSelected = false;
      this.SendSMS.SendSMSArr = [];
      this.SendSMS.SelectedSendSMSObj = {
        value: '',
        text: ''
      };
      this.SendSMS.Message = "";
      this.SendSMS.ReasonArr = [];
      this.SendSMS.SelectedReasonObj = {
        value: '',
        text: ''
      };
      this.SendSMS.Reason = "";
      this.SendSMS.ActualSMSCode = ""; // Reason = ActualSMSCode
    },

    selectAll: function () {
      this.SendSMS.OtherShipmentShippingIDCheckedArr = [];
      let ShippingIDEle;
      if (this.SendSMS.allSelected) {
        var i = 0;
        for (ShippingIDEle in this.SendSMS.OtherShipmentLogArr) {
          this.SendSMS.OtherShipmentShippingIDCheckedArr.push(this.SendSMS.OtherShipmentLogArr[ShippingIDEle].ShippingID.toString());
          if (-1 == this.SendSMS.SMSShipmentData.findIndex(o => o.index == ShippingIDEle)) {
            this.SendSMS.SMSShipmentData.push({
              'index': i,
              'shippingData': this.SendSMS.OtherShipmentLogArr[ShippingIDEle]
            });
          }
          i++;
        }
      } else {
        this.SendSMS.OtherShipmentShippingIDCheckedArr = [];
        for (ShippingIDEle in this.SendSMS.OtherShipmentLogArr) {
          this.SendSMS.SMSShipmentData.splice(this.SendSMS.SMSShipmentData.findIndex(o => o.index == ShippingIDEle), 1);
        }
      }
    },

    select: function (selectedObj, index, event) {

      this.SendSMS.allSelected = false;
      if (event.target.checked) {
        this.SendSMS.SMSShipmentData.push({
          'index': index,
          'shippingData': selectedObj
        });
      } else {
        this.SendSMS.SMSShipmentData.splice(this.SendSMS.SMSShipmentData.findIndex(o => o.index == index), 1);
      }
    },

    selectTicket(selectedObj, index, event) {

      this.allSelected = false;
      if (event.target.checked) {
        this.ticketShipmentData.push({
          'index': index, // 'shippingData': selectedObj
          'shippingData': {
            'shippingid': selectedObj.shippingid,
            'ticketid': selectedObj.ticketid,
            'sourceid': selectedObj.sourceid,
            'tickettypeid': selectedObj.tickettypeid,
            'reasonid': selectedObj.reasonid,
            'subreasonid': selectedObj.subreasonid,
            'ticketstatus': selectedObj.ticketstatus,
            'hub': selectedObj.hub,
            'attempts': selectedObj.attempts,
            'comments': selectedObj.comments,
            'businessflow': selectedObj.businessflow
          }
        });

        let intPosition = this.ticketShipmentData.findIndex(o => o.index == index);

        if (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup' ||
          (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
          (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) {

          this.ticketShipmentData[intPosition].shippingData.reattemptdate = selectedObj.reattemptdate;
        }

        if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
          this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
          this.selectedSubReasonObj.text == 'Redirect to Bank' || this.selectedSubReasonObj.text == 'Change misroute pincode') {

          this.ticketShipmentData[intPosition].shippingData.address = selectedObj.address;
          this.ticketShipmentData[intPosition].shippingData.pincode = selectedObj.pincode;
        }

        if (this.selectedSubReasonObj.text == 'Change payment mode / amount') {

          this.ticketShipmentData[intPosition].shippingData.ordertype = selectedObj.ordertype;
          this.ticketShipmentData[intPosition].shippingData.netpayment = selectedObj.netpayment;
        }

        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No') {

          this.ticketShipmentData[intPosition].shippingData.alternatecontactnumber = selectedObj.alternatecontactnumber;
        }

        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address') {

          this.ticketShipmentData[intPosition].shippingData.emailaddress = selectedObj.emailaddress;
        }

      } else {
        this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == index), 1);
      }
      // if(this.ticketShipmentData.length >= 0){
      // this.shipmentTickets  = this.shipmentSearchedTickets;
      // setTimeout(function(){this.checkboxDisabledForClosedTickets();}.bind(this), 1000);
      // }

    },

    getHubDetailById(HubId, HubSource, IndexId) {
      try {
        const secretKey = constantVariable.enckey;
        const encryptedData = AES.encrypt(HubId.toString(), secretKey).toString();
        let ecHubId = encryptedData.replace(/[=]/g, '_');
        this.input = ({
          id: ecHubId
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getHubDetailById',
            'data': this.input,
            'headers': commonFunction.getusertoken(),
          })
          .then(result => {
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let response = resultDataCrm.data;
              let HubNameStr = '';
              let ProcessLocation = '';
              if (response.code === 200) {
                HubNameStr = response.data[0].HubName;
                if (HubSource === "O") {
                  this.ShipmentTransactionLogSummary.OriginHubData = this.ShipmentTransactionLogSummary.OriginHubData + " " + HubNameStr;
                }
                if (HubSource === "C") {
                  this.SendSMS.OtherShipmentLogArr[IndexId].CurrentHubName = HubNameStr;
                }
                if (HubSource === "D") {
                  this.SendSMS.OtherShipmentLogArr[IndexId].DestinationHubName = HubNameStr;
                } else if (HubSource >= 0) {

                  this.SendSMS.OtherShipmentLogArr[HubSource].DestinationHubName = HubNameStr;
                  this.SendSMS.OtherShipmentLogArr[HubSource].CurrentHubName = HubNameStr;
                }
              } else {
                let msg = response.message;
                this.$alertify.error(msg);
              }

            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - getHubDetailById";
        this.$alertify.error(msg);
      }
    },

    getClientDetailsById(id, i = -1) {
      this.input = ({
        id: id
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getClientDetailsById',
          'data': this.input,
          'headers': commonFunction.getusertoken(),
        })
        .then(result => {
          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let response = resultDataCrm.data;
            if (response.code === 200) {
              if (i >= 0) {
                this.SendSMS.OtherShipmentLogArr[i].ClientName = response.data[0].CompanyName;
              } else {
                this.SendSMS.OtherShipmentLogArr[i].ClientName = null;
              }
            } else {
              let msg = response.message;
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultDataCrm.msg;
            this.$alertify.error(msg);
          }
        }, error => {
          let msg = error;
          this.$alertify.error(msg);
        })
    },
    //End SendSMS functionality
    clearForm() {
      this.txtShippingIDs = '';
      // this.TicketDiv = false;
      // this.SendSMS.SendSMSDiv = false;
    },

    resetForm() {

      var self = this; //you need this because *this* will refer to Object.keys below`

      this.txtShippingIDs = '';

      this.sourceId = '';
      this.selectedSourceObj = {
        value: '',
        text: ''
      };

      this.ticketTypeId = '',
        this.selectedTicketObj = {
          value: '',
          text: ''
        };

      this.reasonId = '',
        this.selectedReasonObj = {
          value: '',
          text: ''
        };

      this.subReasonId = '',
        this.selectedSubReasonObj = {
          value: '',
          text: ''
        };

      this.actionId = '',
        this.selectedActionObj = {
          value: '',
          text: ''
        };

      this.ticketStatusId = '',
        this.selectedTicketStatusObj = {
          value: '',
          text: ''
        };

      this.searchId = '';
      this.selectedSearchObj = {
        value: '',
        text: ''
      };
      this.reAttemptDate = '';
      this.allSelected = false;
      this.address = '';
      this.pincode = '';
      this.orderType = [{
          value: 'CashOnDelivery',
          text: 'CashOnDelivery'
        },
        {
          value: 'PrePaid',
          text: 'PrePaid'
        }
      ];
      this.orderTypeId = '';
      this.selectedOrderTypeObj = {
        value: '',
        text: ''
      };
      this.comments = '';
      this.excelFileUploadPath = '';
      if (this.displayFileUploadDiv == true) {
        document.getElementById('file').value = '';
      }
      this.validated = false;

      if ('none' == document.getElementById('shippingIdDiv').style.display) {
        document.getElementById('shippingIdDiv').style.display = '';
      }
      this.AppointmentDeliveryDate='',     // #bulk_appointment reset appoinment date 
      //#bulk b2b_alternate_instruction - Delivery/Pickup 
      this.reattemptTimeSlotWithDate='',     
      this.contactNumber='', 
      this.pickupAddress= '',
      this.PickupTimeSlotWithDate='',
      //#bulk b2b_alternate_instruction - Delivery/Pickup End
      this.SendSMS.SendSMSDiv = false;
      this.getSMSReason();

    },

    resetFormFilters() {

      this.searchId = '';
      this.selectedSearchObj = {
        value: '',
        text: ''
      };

      this.sourceId = '';
      this.selectedSourceObj = {
        value: '',
        text: ''
      };

      this.ticketTypeId = '';
      this.selectedTicketObj = {
        value: '',
        text: ''
      };

      this.reasonId = '';
      this.reason = [];
      this.selectedReasonObj = {
        value: '',
        text: ''
      };

      this.subReasonId = '';
      this.subReason = [];
      this.selectedSubReasonObj = {
        value: '',
        text: ''
      };

      this.actionId = '';
      this.action = [];
      this.selectedActionObj = {
        value: '',
        text: ''
      };

      this.ticketStatusId = '';
      this.selectedTicketStatusObj = {
        value: '',
        text: ''
      };

      this.allSelected = false;
      this.editHoldTicket = false;
      this.fromDate = '';
      this.toDate = '';
      this.showList = 0;

      this.selectAllRecord = false;
      this.Ticketmodal = false;
      this.filter = '';
    },

    resetTicket(message) {

      this.sourceId = '';
      this.selectedSourceObj = {
        value: '',
        text: ''
      };

      this.ticketTypeId = '',
        this.selectedTicketObj = {
          value: '',
          text: ''
        };

      this.reasonId = '',
        this.selectedReasonObj = {
          value: '',
          text: ''
        };

      this.subReasonId = '',
        this.selectedSubReasonObj = {
          value: '',
          text: ''
        };

      this.actionId = '',
        this.selectedActionObj = {
          value: '',
          text: ''
        };

      this.ticketStatusId = '';
      this.selectedTicketStatusObj = {
        value: '',
        text: ''
      };

      this.searchId = '';
      this.selectedSearchObj = {
        value: '',
        text: ''
      };
      this.reAttemptDate = '';
      this.comments = '';

      if ('raise_ticket' == message) {
        this.excelFileUploadPath = '';
      }
      this.validated = false;

    },

    selectAllCheckbox() {
      //this.rackIds = [];
      if (this.selectAllRecord) {
        var i = 0;

        for (let indexId in this.shipmentTickets) {

          if (this.ticketIDS.indexOf(this.shipmentTickets[indexId].ticketid) == -1) {
            this.ticketIDS.push(this.shipmentTickets[indexId].ticketid);

            this.ticketShipmentData.push({
              'index': i, // 'shippingData': this.shipmentTickets[indexId],
              'shippingData': {
                'shippingid': this.shipmentTickets[indexId].shippingid,
                'hub': this.shipmentTickets[indexId].hub,
                'attempts': this.shipmentTickets[indexId].attempts,
                'comments': this.shipmentTickets[indexId].comments,
                'businessflow': this.shipmentTickets[indexId].businessflow
              }

            });

            if (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup' ||
              (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
              (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) {

              this.ticketShipmentData[indexId].shippingData.reattemptdate = this.shipmentTickets[indexId].reattemptdate;
            }

            if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
              this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
              this.selectedSubReasonObj.text == 'Redirect to Bank' || this.selectedSubReasonObj.text == 'Change misroute pincode') {

              this.ticketShipmentData[indexId].shippingData.address = this.shipmentTickets[indexId].address;
              this.ticketShipmentData[indexId].shippingData.pincode = this.shipmentTickets[indexId].pincode;
            }

            if (this.selectedSubReasonObj.text == 'Change payment mode / amount') {

              this.ticketShipmentData[indexId].shippingData.ordertype = this.shipmentTickets[indexId].ordertype;
              this.ticketShipmentData[indexId].shippingData.netpayment = this.shipmentTickets[indexId].netpayment;
            }

            if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No') {

              this.ticketShipmentData[indexId].shippingData.alternatecontactnumber = this.shipmentTickets[indexId].alternatecontactnumber;
            }

            if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address') {

              this.ticketShipmentData[indexId].shippingData.emailaddress = this.shipmentTickets[indexId].emailaddress;
            }
          }
          i++;
        }
      } else {
        for (let indexId in this.shipmentTickets) {
          if (this.ticketIDS.indexOf(this.shipmentTickets[indexId].ticketid) >= 0) {

            this.ticketIDS.splice(this.ticketIDS.indexOf(this.shipmentTickets[indexId].ticketid), 1);
            this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == this.shipmentTickets[indexId].indexId), 1);
          }
        }
      }
    },

    SummaryOption(dataObj) {
      this.resetFormFilters();
      this.SummarySelectOptionObj = dataObj;

      this.businessFlowId = this.SummarySelectOptionObj.text;
      this.getSearchtags(this.businessFlowId);
    },

    searchButton() {
      this.$route.params.message = '';
      // if (this.sourceId === '') {
      //   this.$alertify.error('Please select Source.');
      //   return false;
      // }
      if(this.fromDate == ''){
        this.$alertify.error('Please select From Date.');
        return false;
      }
      if(this.toDate == ''){
        this.$alertify.error('Please select To Date.');
        return false;
      }
      if (this.ticketTypeId === '') {
        this.$alertify.error('Please select Ticket Type.');
        return false;
      }
      if (this.reasonId === '') {
        this.$alertify.error('Please select Reason.');
        return false;
      }
      if (this.subReasonId === '') {
        this.$alertify.error('Please select SubReason.');
        return false;
      }
      if (this.$route.params.message !== '' || this.$route.params.message !== undefined) {
        if (this.actionId === '') {
          this.$alertify.error('Please select Action.');
          return false;
        }
      }
      if (this.ticketStatusId === '') {
        this.$alertify.error('Please select Ticket Status.');
        return false;
      }
      
      //Old validation =>  Not in use, added validation for from data and to date in start
      // if (this.fromDate == '' && this.toDate != '') {
      //   this.$alertify.error('Please select From Date.');
      //   return false;
      // }
      // if (this.fromDate != '' && this.toDate == '') {
      //   this.$alertify.error('Please select To Date.');
      //   return false;
      // }
      this.pageNo = this.pageCount = 0;
      this.getFilteredTickets();
    },


    exportToExcel() {

      try {
        if (this.showList == 0) {

          /*
          if( this.fromDate == '' ) {
            this.$alertify.error('Please select From Date.');
            return false;
          }
          if( this.toDate == '' ) {
            this.$alertify.error('Please select To Date.');
            return false;
          }
          if( this.fromDate == '' && this.toDate != '' ) {
            this.$alertify.error('Please select From Date.');
            return false;
          }
          if( this.fromDate != '' && this.toDate == '' ) {
            this.$alertify.error('Please select To Date.');
            return false;
          }
*/
          // if (this.sourceId === '') {
          //   this.$alertify.error('Please select Source.');
          //   return false;
          // }
          if(this.fromDate == ''){
            this.$alertify.error('Please select From Date.');
            return false;
          }
          if(this.toDate == ''){
            this.$alertify.error('Please select To Date.');
            return false;
          }
          if (this.ticketTypeId === '') {
            this.$alertify.error('Please select Ticket Type.');
            return false;
          }
        }

        if (this.actionId == 'Multiple') {
          this.actionId = '';
        }
        if (this.sourceId == 'Multiple') {
          this.sourceId = '';
        }

        this.isLoading = true;

        let searchData = {
          fromdate: (this.fromDate != '') ? moment(String(this.fromDate)).format('YYYY-MM-DD') : '',
          todate: (this.toDate != '') ? moment(String(this.toDate)).format('YYYY-MM-DD') : '',
          sourceId: this.sourceId,
          ticketTypeId: this.ticketTypeId,
          source: this.selectedSourceObj.text,
          ticketType: this.selectedTicketObj.text,
          businessFlow: this.businessFlowId,
          reasonId: this.reasonId,
          subReasonId: this.subReasonId,
          actionId: this.actionId,
          ticketStatusId: this.selectedTicketStatusObj.text,
          // activeSubDepartmentName:this.activeSubDepartmentName,
        }

        if (this.ticketStatusId == 'Multiple') {
          searchData.ticketStatusId = '';
        }

        axios({
          url: apiUrl.api_url + 'exportB2BBulkTickets',
          method: 'POST',
          data: searchData,
          responseType: 'blob', // important
          headers: commonFunction.getusertoken(),
        }).then((response) => {
          this.isLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'B2BBulkTicketShipmentReport.xlsx');
          document.body.appendChild(link);
          link.click();

        });

      } catch (error) {
        let msg = error + " - exportToExcel";
        this.$alertify.error(msg);
      }
    },

    async getPaginationData(pageNum) {

      this.pageNo = (pageNum - 1) * this.perPage;
      await this.getFilteredTickets();
    },

    getFilteredTickets() {
      try {
        this.allSelected = false;
        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
          this.isModelLoading = true;
        } else {
          this.isLoading = true;
        }

        this.ticketIDS = [];
        this.ticketShipmentData = [];
        this.shipmentTickets = [];
        this.selectAllRecord = false;
        this.filter = '';
        var type = '';
        type = this.$route.params.type;
        var searchData = {};
        this.listTotalCount = 0;
        var ticketStatusIdstr = '';
        if (this.$route.params.message) {
          var ticketSummeryListforBulkEdit = this.$route.params.ticketSummeryListforBulkEdit;
          if (this.sourceId == 'Multiple') {
            this.sourceId = '';
          }
          if (this.actionId == 'Multiple') {
            var actionIdTemp = '';
          }
          // this.ticketStatusId='';
          if (type == 'Inquiry') {
            var dateInquiry = new Date();
            dateInquiry = commonFunction.reformatDateString(this.searchDate.toLocaleDateString());
            ticketStatusIdstr = "IN ('Open','Follow Up','Closed')";

            var closedTicketsChecked = true;
            if (ticketSummeryListforBulkEdit.length > 1) {
              for (let i = 0; i < ticketSummeryListforBulkEdit.length; i++) {
                if ("Closed" !== ticketSummeryListforBulkEdit[i].ticketstatus) {
                  closedTicketsChecked = false;
                }
              }
            } else {
              if ("Closed" !== ticketSummeryListforBulkEdit[0].ticketstatus) {
                closedTicketsChecked = false;
              }
            }
          } else {
            ticketStatusIdstr = "IN ('Open','Follow Up')";
            var dateInquiry = '';
          }

          // this.businessFlowId=this.$route.params.businessFlowObj.text;
          this.clientName = this.$route.params.userClientNameBulk;
          var hubId = this.$route.params.hubObj.value.toString();
          var userId = this.$route.params.useridBulk;
          var deptId = this.$route.params.deptidBulk;

          var isEscalation = 0;
          if (type == 'Escalation') {
            isEscalation = 't.isescalation = 1';
          } else {
            isEscalation = 't.isescalation = 0';
          }
        } else {
          var userId = '';
          var deptId = '';
          var hubId = '';
          this.clientName = '';
          if (this.ticketStatusId == 'Multiple') {
            ticketStatusIdstr = '';
          } else {
            ticketStatusIdstr = "IN ('" + this.selectedTicketStatusObj.text + "')";
          }
          var isEscalation = '';
          var dateInquiry = '';
        }
        if (this.actionId !== 'Multiple') {
          var actionIdTemp = this.actionId;
        } else {
          var actionIdTemp = '';
        }

        if (this.ticketStatusId == 3 || closedTicketsChecked == true) {
          this.updateTicketButtoncheck = true;
          // this.$alertify.error("Closed tickets can not get updated.");
        } else {
          this.updateTicketButtoncheck = false;
        }
        if (this.updateTicketButtoncheck == true) {
          this.updateTicketButton = true;
        } else {
          this.updateTicketButton = false;
        }
        const secretKey = constantVariable.enckey;
        const ticketStatusIdstr1 = AES.encrypt(ticketStatusIdstr, secretKey).toString();
        const ticketStatusIdstr2 = ticketStatusIdstr1.replace(/[=]/g, '_');
        const isEscalation1 = AES.encrypt(isEscalation, secretKey).toString();
        const isEscalation2 = isEscalation1.replace(/[=]/g, '_');
        searchData = {
          fromdate: (this.fromDate != '') ? moment(String(this.fromDate)).format('YYYY-MM-DD') : '',
          todate: (this.toDate != '') ? moment(String(this.toDate)).format('YYYY-MM-DD') : '',
          sourceId: this.sourceId,
          ticketTypeId: this.ticketTypeId,
          reasonId: this.reasonId,
          subReasonId: this.subReasonId,
          actionId: actionIdTemp,
          ticketStatusId: ticketStatusIdstr2,
          offset: this.pageNo,
          limit: this.perPage,
          businessFlow: this.businessFlowId,
          clientName: this.clientName,
          hubId: hubId,
          userId: userId,
          deptId: deptId,
          isEscalation: isEscalation2,
          dateInquiry: dateInquiry
        }
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getB2BFilteredTickets',
          'data': searchData,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.showList = 1;
          this.searchListDiv = false;

          if (true == result.data.data.status) {
            this.shipmentTickets = result.data.data.data;
            // this.shipmentSearchedTickets = this.shipmentTickets;
            if (this.shipmentTickets.length > 0) {
              this.listTotalCount = this.shipmentTickets[0].full_count;
              if (this.listTotalCount < this.perPage) {
                this.pageCount = 1;
                this.pageno = 0;
              } else {
                this.pageCount = Math.ceil(this.listTotalCount / this.perPage)
              }
            } else {
              this.pageCount = 0;
            }
            this.$route.params.message = '';
            setTimeout(function () {
              this.checkboxDisabledForClosedTickets();
            }.bind(this), 1000);
          }
          if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
            this.isModelLoading = false;
          } else {
            this.isLoading = false;
            this.isLoadingPagination = false;
          }

        }, error => {
          let msg = error;
          this.$alertify.error(msg);
          if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
            this.isModelLoading = false;
          } else {
            this.isLoading = false;
            this.isLoadingPagination = false;
          }
        })
      } catch (error) {
        this.Ticketmodal = false;
        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
          this.isModelLoading = false;
        } else {
          this.isLoading = false;
          this.isLoadingPagination = false;
        }
        let msg = error + " - getFilteredTickets";
        this.$alertify.error(msg);
      }
    },

    checkboxDisabledForClosedTickets() {
      let o;
      let self = this;
      var checkClosed = false;
      for (o in this.shipmentTickets) {
        if ('Closed' == this.shipmentTickets[o].ticketstatus) {
          document.getElementById(this.shipmentTickets[o].ticketid).disabled = true;
          checkClosed = true;
        } else {
          document.getElementById(this.shipmentTickets[o].ticketid).disabled = false;
        }
      }
      if (checkClosed == true) {
        this.selectAllRecord = false;
        this.closedUnSelectedAll = true;
      } else {
        this.selectAllRecord = false;
        this.closedUnSelectedAll = false;
      }
    },

    hasDuplicates(arr) {
      return new Set(arr).size !== arr.length;
    },
   
    ShowRaiseTicketDiv(message) {
      try {
        this.searchListDiv = false;
        this.closedUnSelectedAll = false;
        // this.selectedBusinessFlowObj = { 'value' : '1', 'text' : 'Forward' };
        if (this.$route.params.message) {
          this.TicketDiv = false;
          this.searchBatchDiv = false;
          this.BatchListDiv = false;
          this.displayFileUploadDiv = false;
          this.displayShippingDiv = false;
          this.RaiseTicketDiv = false;
          message = this.$route.params.message;
          var dataObj = this.$route.params.businessFlowObj;
          this.SummaryOption(dataObj);
          this.page = 'trackshipment';
          this.currentSelectedTab = message;
          this.selected_action = message;
          this.getTrackingSource();
          return false;
        }
        if (message !== "raise_ticket" && message != 'address_change') {
          this.selectedBusinessFlowObj = {
            'value': '1',
            'text': 'Forward'
          };
        }
        this.currentSelectedTab = message;
        this.selected_action = message;

        this.checkAllSelected = false;
        this.showList = 0;
        this.Ticketmodal = false;
        this.page = 'b2bbulkshipment';
        console.log("this.select_action is :",this.selected_action);
        if (this.selected_action == 'edit_bulk_tickets') {
          this.page = 'b2b';
          this.businessFlowId = "Forward"
        }
        this.resetTicket(message);
        this.messageBulk = message;
        this.searchDate = new Date();
        if ('raise_ticket_tab' == message) {
          this.txtShippingIDs = '';
          this.TicketDiv = false;
          this.searchBatchDiv = true;
          this.BatchListDiv = false;
          this.displayShippingDiv = true;
          this.displayFileUploadDiv = false;
        }

        if ('raise_ticket' == message) {
          this.usertype = "Agent";
          this.searchDate = new Date();
          this.searchBatchDiv = true;
          this.BatchListDiv = false;
          if (this.displayShippingDiv == true) {
            let strShippingIds = this.txtShippingIDs.toString().replace(/^,|,$/g, '');
            let ShippingIDsArr = strShippingIds.split(',');
            if (strShippingIds === '') {
              this.$alertify.error('Please enter shipping ids.');
              this.RaiseTicketDiv = false;
              return false;
            } else if(ShippingIDsArr.length>constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT && this.selectedBusinessFlowObj.text === 'Forward'){    // #bulk_appointment Forward  limit message
              this.$alertify.error('NOTE: only '+constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT+' AWB IDs are allowed to be processed at once.');
              this.RaiseTicketDiv = false;
              return false;
            }else if(ShippingIDsArr.length>constantVariable.APPOINMENT_DATE_B2BBULK_LIMIT && this.selectedBusinessFlowObj.value === '2'){  // #bulk_appointment Appoinment date  limit message
                this.$alertify.error('NOTE: only '+constantVariable.APPOINMENT_DATE_B2BBULK_LIMIT+' AWB IDs are allowed to be processed at once.');
                this.RaiseTicketDiv = false;
                return false;
            }
            else if(this.hasDuplicates(ShippingIDsArr)){
              this.$alertify.error('Duplicate AWB is present');
              this.RaiseTicketDiv = false;
              return false;
            }
            else {
              this.TicketDiv = true;
              this.RaiseTicketDiv = true;
              this.searchBatchDiv = false;
            }

            /*
            //start  rtoh 1000 / 5000 validation for b2B and B2C  
            let txtShippingIDs = this.txtShippingIDs;
            if (txtShippingIDs != '') {
              let msgAlert=''; 
              txtShippingIDs = txtShippingIDs.trim();
              let ShippingIDsArr = txtShippingIDs.split(',');
              let ArrCnt = ShippingIDsArr.length;
              if (this.businessFlowId === 'Forward' && this.rdoB2C === 'B2CHeavies' && ArrCnt > constantVariable.FORWARD_REQUEST_B2C_HEAVY_BULK_LIMIT) {
                msgAlert = "For B2C Heavies - only "+constantVariable.FORWARD_REQUEST_B2C_HEAVY_BULK_LIMIT+" AWB IDs are allowed to be processed at once";
                this.$alertify.error(msgAlert);
                return false;
              }
              else if (this.businessFlowId === 'Forward' && this.rdoB2C === 'B2CHeavies') {
           this.getMPSGroupIdwithPartialRTOAllowedData();
           this.TicketDiv = true;
           this.RaiseTicketDiv = true;
           this.searchBatchDiv = false;
           return false;
              }



              // else if (this.businessFlowId === 'Forward' && this.rdoB2C === 'B2CEcom' && ArrCnt > 5000) {
              //    msgAlert = "For B2C Ecom - only 5000 AWB IDs are allowed to be processed at once";
              //   this.$alertify.error(msgAlert);
              //   return false;
              // }
            }
            // end 1000 / 5000 validation for b2B and B2C
*/

          }
          this.displayShippingDiv = true;
          this.displayFileUploadDiv = false;
        }

        if ('address_change' == message) {
          this.txtShippingIDs = '';
          this.TicketDiv = false;
          this.usertype = "Agent";
          this.searchDate = new Date();
          this.searchBatchDiv = true;
          this.BatchListDiv = false;
          if (this.displayFileUploadDiv == false) {

            this.displayFileUploadDiv = true;
            this.displayShippingDiv = false;
            this.RaiseTicketDiv = false;
            return false;
          }

          if (this.RaiseTicketDiv == true) {
            this.RaiseTicketDiv = false;
          }

          if (this.excelFileUploadPath === '') {

            if (this.displayFileUploadDiv == false) {
              this.$alertify.error('Please Upload excel for address.');
              this.RaiseTicketDiv = false;

            } else {
              this.$alertify.error('Please Upload excel for address.');
              this.RaiseTicketDiv = false;
            }
          } else {
            this.TicketDiv = true;
            this.RaiseTicketDiv = true;
            this.searchBatchDiv = false;
          }
          this.displayShippingDiv = false;
          this.displayFileUploadDiv = true;
        }

        if ('edit_bulk_tickets' == message) {
          this.resetFormFilters();
          this.TicketDiv = false;
          this.searchBatchDiv = false;
          this.BatchListDiv = false;
          this.displayFileUploadDiv = false;
          this.displayShippingDiv = false;
          this.RaiseTicketDiv = false;
        }
        this.SendSMS.SendSMSDiv = false;

        if ('edit_bulk_tickets' != message) {
          this.getSearchtags(this.businessFlowId);
        } else {
          this.SummarySelectOptionObj={
            text:"Forward",
            value:"1"
          }
          this.getSearchtags(this.SummarySelectOptionObj.text);
        }
        this.getTrackingSource();
        this.getTrackingMainType();
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - ShowRaiseTicketDiv";
        this.$alertify.error(msg);
      }
    },

    getTrackingSource() {

      let projectID = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';

      this.input = ({
        'departmentid': '1',
        'usertype': this.usertype,
        'businesstype': 'Cargo'
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingSource',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.source = result.data.data.data;
        if (this.$route.params.message) {
          var ticketSummeryListforBulkEdit = this.$route.params.ticketSummeryListforBulkEdit;
          if (ticketSummeryListforBulkEdit.length > 1) {
            this.multipleValues = 0;
            for (let i = 0; i < ticketSummeryListforBulkEdit.length; i++) {

              if (ticketSummeryListforBulkEdit[0].source !== ticketSummeryListforBulkEdit[i].source) {
                this.multipleValues = 1;
              }
            }
            if (this.multipleValues == 0) {
              this.selectedSourceObj.text = ticketSummeryListforBulkEdit[0].source;
              this.selectedSourceObj.value = ticketSummeryListforBulkEdit[0].sourceid;
              this.sourceId = ticketSummeryListforBulkEdit[0].sourceid;
            } else {
              this.selectedSourceObj.text = 'Multiple';
              this.selectedSourceObj.value = 'Multiple';
              this.sourceId = 'Multiple';
            }
          } else {
            this.selectedSourceObj.text = ticketSummeryListforBulkEdit[0].source;
            this.selectedSourceObj.value = ticketSummeryListforBulkEdit[0].sourceid;
            this.sourceId = ticketSummeryListforBulkEdit[0].sourceid;
          }

          this.getTrackingMainType();
        }

      }, error => {
        this.isLoading = false;
        this.RaiseTicketDiv = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },

    selectedSource(sourceData) {
      try {
        this.selectedSourceObj = sourceData;
        this.sourceId = sourceData.value;

        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === false) {
          this.showList = 0;
        }
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - selectedSource";
        this.$alertify.error(msg);
      }
    },

    selectedTicket(ticketData) {
      try {
        this.selectedTicketObj = ticketData;
        this.ticketTypeId = ticketData.value.toString();
        this.selectedSearchObj = {};
        this.selectedReasonObj = {};
        this.reasonId = '';
        this.selectedSubReasonObj = {};
        this.subReason = [];
        this.subReasonId = '';
        this.selectedActionObj = {};
        this.selectedTicketStatusObj = {
          text: '',
          value: ''
        };
        this.actionId = '';
        this.ticketStatusId = '';
        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === false) {
          this.showList = 0;
        }
        this.getTrackingSubType(this.ticketTypeId, this.businessFlowId, 'Add', '');
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - selectedTicket";
        this.$alertify.error(msg);
      }
    },
    // #bulk_appointment Dropdown changes
    selectedBusinessFlow(businessFlowData) {

      this.resetForm();
      this.showList = 0;
      // Always keep businessFlowId as "Forward" for backend
      this.businessFlowId = 'Forward';
      this.selectedBusinessFlowObj = businessFlowData;
    
      this.RaiseTicketDiv = false;
      this.searchBatchDiv = true;
      // Conditional logic based on selected text (UI handling)
      if (businessFlowData.text === 'Forward') {
        this.bulkShippingIDsMessage = this.bulkLimitShippingIDsMessage;
        this.rdoB2CDivDisplay = true;
      } else if (businessFlowData.value === '2') {
        this.bulkShippingIDsMessage = this.appoinmentDateMessage;
        this.rdoB2CDivDisplay = false;
      } else {
        this.bulkShippingIDsMessage = null;
        this.rdoB2CDivDisplay = false;
      }

    },

    selectedMethod(method) {
      this.selectedMethodObj = method;
      this.methodId = method.value;
      if (this.subReasonId == 44) {
        if (this.methodId == 1) {
          this.orderTypeId = "CashOnDelivery";
        } else {
          this.orderTypeId = "PrePaid";
        }
      }
    },

    selectedReason(reasonData) {
      try {
        this.selectedReasonObj = reasonData;
        this.reasonId = reasonData.value.toString();
        this.selectedSearchObj = {};
        this.selectedSubReasonObj = {};
        this.subReasonId = '';
        this.selectedActionObj = {};
        this.actionId = '';
        this.selectedTicketStatusObj = {};
        this.ticketStatusId = '';

        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === false) {
          this.showList = 0;
        }

        if (this.selected_action == 'edit_bulk_tickets') {
          if (this.ticketShipmentData.length > 0) {
            this.getTrackingType(this.reasonId, this.businessFlowId, 'Edit', this.objTicketSearch.subReasonId);
          } else {
            this.getTrackingType(this.reasonId, this.businessFlowId, 'Add', '');
          }

          this.input.category = '';
          this.input.notificationStatus = '';
        } else {
          this.getTrackingType(this.reasonId, this.businessFlowId, 'Add', '');
        }
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - selectedReason";
        this.$alertify.error(msg);
      }
    },

    selectedSubReason(subReasonData) {

      try {
        this.reAttemptDate = '';

        this.selectedSubReasonObj = subReasonData;
        this.subReasonId = subReasonData.value.toString();
        this.selectedSearchObj = {};
        this.selectedActionObj = {
          text: '',
          value: ''
        };
        this.actionId = '';
        this.selectedTicketStatusObj = {
          text: '',
          value: ''
        };
        this.ticketStatusId = '';
        this.escalation = subReasonData.isescalation;

        this.showList = 0;
        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === false) {
          this.getTicketAction(this.subReasonId, 'Add');
        } else if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
          this.getTicketAction(this.subReasonId, 'Edit');
        } else {
          this.getTicketAction(this.subReasonId, 'Add');
        }
        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
          if (this.subReasonId == 44) {
            var method = {
              value: '',
              text: ''
            };
            if (this.OrderDetails.OrderType == 'Prepaid') {
              method = {
                value: 2,
                text: 'Prepaid'
              };
              this.selectedMethod(method);
            } else {
              method = {
                value: 1,
                text: 'COD'
              };
              this.selectedMethod(method);
            }
          }
        }

      } catch (error) {
        this.isLoading = false;
        let msg = error + " - selectedSubReason";
        this.$alertify.error(msg);
      }
    },

    selectedAction(actionData) {

      try {
        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === false) {
          this.showList = 0;
        }

        if (this.selectedSubReasonObj.text !== 'Urgent delivery' && this.selectedSubReasonObj.text !== 'Urgent pickup' && this.selectedSubReasonObj.text !== 'RTO Reattempt' && this.selectedSubReasonObj.text !== 'Fake update' && this.selectedSubReasonObj.text !== 'DTO Reattempt' && this.selectedSubReasonObj.text !== 'Change Reattempt Date' &&
          this.selectedSubReasonObj.value !== constantVariable.DELAY_IN_PICKUP_SUB_REASON && this.selectedSubReasonObj.value !== constantVariable.FAKE_NPR &&
          this.selectedSubReasonObj.value !== constantVariable.DENIED_PICKUP && this.selectedSubReasonObj.value !== constantVariable.FAKE_NDR && this.selectedSubReasonObj.value !== constantVariable.REFUSED_DOORSTEP_DELIVERY && this.selectedSubReasonObj.text !== 'Delay in service') {

          this.endDate = null;
          if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup' || this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'PDD Crossed' ||
            this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON || this.selectedSubReasonObj.value == constantVariable.FAKE_NPR ||
            this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR || this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY) {

            let tomorrow = new Date();
            if (this.startDate.getHours() < 20) {
              tomorrow.setDate(tomorrow.getDate() + 1);
              this.startDate = tomorrow;
            } else {
              tomorrow.setDate(tomorrow.getDate() + 2);
              this.startDate = tomorrow;
            }
            let dateDisabled = new Date();
            dateDisabled.setDate(dateDisabled.getDate() + 7);
            this.endDate = dateDisabled;
          }

        } else {
          this.startDate = new Date();
          let dateDisabled2 = new Date();
          dateDisabled2.setDate(dateDisabled2.getDate() + 6);
          this.endDate = dateDisabled2;
        }

        if (this.selected_action == 'edit_bulk_tickets' || this.Ticketmodal == true) {
          if (this.ticketShipmentData.length > 0 && this.ticketShipmentData[0].shippingData.OrderType && this.ticketShipmentData[0].shippingData.OrderType != null) {

            // if (this.ticketShipmentData[0].shippingData.ordertype == 'COD') {
            //   this.orderTypeId = "PrePaid";
            // }
            // if (this.ticketShipmentData[0].shippingData.ordertype == 'PrePaid') {
            //   this.orderTypeId = "CashOnDelivery";
            // }

            // if (this.ticketShipmentData[0].shippingData.OrderType.toLowerCase() == 'cod') {
            //   this.orderTypeId = "PrePaid";
            // }
            // if (this.ticketShipmentData[0].shippingData.OrderType.toLowerCase() == 'prepaid') {
            //   this.orderTypeId = "CashOnDelivery";
            // }

            var method = {
              value: '',
              text: ''
            };
            if (this.ticketShipmentData[0].shippingData.OrderType.toLowerCase() == 'cod') {
              // this.orderTypeId = "PrePaid";
              this.orderTypeId = "CashOnDelivery";
              method = {
                value: 1,
                text: 'COD'
              };
              this.selectedMethod(method);
            }
            if (this.ticketShipmentData[0].shippingData.OrderType.toLowerCase() == 'prepaid') {
              // this.orderTypeId = "CashOnDelivery";
              this.orderTypeId = "PrePaid";
              method = {
                value: 2,
                text: 'Prepaid'
              };
              this.selectedMethod(method);
            }

          }
        }
        this.disPayment = true;

        this.selectedActionObj = actionData;
        this.actionId = actionData.value.toString();

        if (this.selected_action != 'edit_bulk_tickets' || this.Ticketmodal == true) {
          this.getTicketActionStatus(actionData.value);
        }
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - selectedAction";
        this.$alertify.error(msg);
      }
    },

    selectedTicketStatus(ticketStatusData) {
      this.showList = 0;
      if (this.$route.params.message) {
        var ticketSummeryListforBulkEdit = this.$route.params.ticketSummeryListforBulkEdit;
        // console.log( ' ticketSummeryListforBulkEdit : '+ticketSummeryListforBulkEdit.length );

        if (ticketSummeryListforBulkEdit.length > 1) {
          this.multipleValues = 0;
          for (let i = 0; i < ticketSummeryListforBulkEdit.length; i++) {
            if (ticketSummeryListforBulkEdit[0].ticketstatus !== ticketSummeryListforBulkEdit[i].ticketstatus) {
              this.multipleValues = 1;
            }
          }
          if (this.multipleValues == 0) {
            var ticketstatusvalue = 0;
            if (ticketSummeryListforBulkEdit[0].ticketstatus == "Open") {
              ticketstatusvalue = 1;
            } else if (ticketSummeryListforBulkEdit[0].ticketstatus == "Closed") {
              ticketstatusvalue = 3;
            } else {
              ticketstatusvalue = 2;
            }
            this.selectedTicketStatusObj = {
              text: ticketSummeryListforBulkEdit[0].ticketstatus,
              value: ticketstatusvalue.toString()
            };
            this.ticketStatusId = ticketstatusvalue.toString();
          } else {
            this.selectedTicketStatusObj = {
              text: 'Multiple',
              value: 'Multiple'
            };
            this.ticketStatusId = 'Multiple';
          }
        } else {
          var ticketstatusvalue = 0;

          if (ticketSummeryListforBulkEdit[0].ticketstatus == "Open") {
            ticketstatusvalue = 1;
          } else if (ticketSummeryListforBulkEdit[0].ticketstatus == "Closed") {
            ticketstatusvalue = 3;
          } else {
            ticketstatusvalue = 2;
          }
          this.selectedTicketStatusObj = {
            text: ticketSummeryListforBulkEdit[0].ticketstatus,
            value: ticketstatusvalue.toString()
          };
          this.ticketStatusId = ticketstatusvalue.toString();
        }
      } else {
        this.selectedTicketStatusObj = ticketStatusData;
        this.ticketStatusId = ticketStatusData.value.toString();
      }
    },

    selectedOrderType(orderTypeData) {
      this.selectedOrderTypeObj = orderTypeData;
      this.orderTypeId = orderTypeData.value;
    },

    selectedSearchTag(SelectedTagData) {
      this.showList = 0;
      this.resetTicket(this.selected_action);
      this.selectedSearchObj = SelectedTagData;
      this.searchId = SelectedTagData.value;
      this.getSearchResult(SelectedTagData.id, SelectedTagData.type, this.businessFlowId);
    },

    getTicketActionStatus(actionId) {

      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';

      this.input = ({
        actionId: actionId,
        status: (this.selected_action == 'edit_bulk_tickets') ? 'Edit' : 'Add'
      });

      if (this.selected_action == 'edit_bulk_tickets') {
        this.input.tab = 'edit_bulk_tickets';
      }

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTicketActionStatus',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        if (result.data.data.status == true) {
          let arrStatus = [];
          this.ticketStatus = [];
          arrStatus = result.data.data.data[0].ticketstatus.toString().split(",");

          for (let i = 0; i < arrStatus.length; i++) {
            this.ticketStatus.push({
              'value': arrStatus[i],
              'text': arrStatus[i]
            });

          }

          this.selectedTicketStatusObj = {
            text: this.ticketStatus[0].text,
            value: this.ticketStatus[0].value.toString()
          };
          this.ticketStatusId = this.selectedTicketStatusObj.value;

        }

      }, error => {

        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTrackingMainType() {

      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';

      this.input = ({
        'departmentid': '1',
        'page': this.page
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingMainType',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.ticketType = result.data.data.data;
        if (this.selectedBusinessFlowObj.text == 'Banking Client' || this.selected_action == 'address_change') {

          var indexTicket = this.ticketType.findIndex(o => o.text == 'Complaint');
          if (-1 !== indexTicket) {
            this.ticketType.splice(indexTicket, 1);
          }
        }
        if (this.$route.params.message) {
          var ticketSummeryListforBulkEdit = this.$route.params.ticketSummeryListforBulkEdit;
          this.selectedTicketObj.text = ticketSummeryListforBulkEdit[0].maintype;
          this.selectedTicketObj.value = ticketSummeryListforBulkEdit[0].tickettypeid;
          this.ticketTypeId = ticketSummeryListforBulkEdit[0].tickettypeid;
          this.getTrackingSubType(this.ticketTypeId.toString(), this.businessFlowId, 'Add', '');
        }
      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTrackingSubType(mainTypeId, businessFlow, type, subReasonId) {

      let accessToken;

      if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
        this.isModelLoading = true;
      } else {
        this.isLoading = true;
      }
      let token = 'edw3r323432472748923';
      const secretKey = constantVariable.enckey;
      const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
      let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
      this.input = ({
        'departmentid': ecDepartmentID,
        'maintypeid': mainTypeId,
        'businessFlow': (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
        'type': type,
        'subReasonId': subReasonId,
        'page': this.page
      });
      if (this.selected_action == 'edit_bulk_tickets') {

        this.input.category = '';
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingSubType',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.reason = result.data.data.data;

        if (this.reason) {

          if (this.$route.params.message) {
            var ticketSummeryListforBulkEdit = this.$route.params.ticketSummeryListforBulkEdit;
            this.selectedReasonObj.text = ticketSummeryListforBulkEdit[0].subtype;
            this.selectedReasonObj.value = ticketSummeryListforBulkEdit[0].reasonid;
            this.reasonId = ticketSummeryListforBulkEdit[0].reasonid;
            this.getTrackingType(this.reasonId.toString(), this.businessFlowId, 'Add', '');
          }
          if (this.selected_action != 'edit_bulk_tickets') {

            if (this.selected_action == 'raise_ticket') {
              if (businessFlow == 'Forward' || businessFlow == 'Reverse') {
                var index = this.reason.findIndex(o => o.text == 'Address change');
                if (-1 !== index) {
                  this.reason.splice(index, 1);
                }
              }
            } else {

              if (businessFlow == 'Forward') {
                var indexArrange = this.reason.findIndex(o => o.text == 'Arrange delivery');
                if (-1 !== indexArrange) {
                  this.reason.splice(indexArrange, 1);
                }

                var indexCancellation = this.reason.findIndex(o => o.text == 'Cancellation Request');
                if (-1 !== indexCancellation) {
                  this.reason.splice(indexCancellation, 1);
                }

                var indexStatus = this.reason.findIndex(o => o.text == 'Change status');
                if (-1 !== indexStatus) {
                  this.reason.splice(indexStatus, 1);
                }

                var indexHold = this.reason.findIndex(o => o.text == 'Hold');
                if (-1 !== indexHold) {
                  this.reason.splice(indexHold, 1);
                }
              } else if (businessFlow == 'Reverse') {

                var indexArrange = this.reason.findIndex(o => o.text == 'Arrange pickup');
                if (-1 !== indexArrange) {
                  this.reason.splice(indexArrange, 1);
                }

                var indexCancellation = this.reason.findIndex(o => o.text == 'Cancellation Request');
                if (-1 !== indexCancellation) {
                  this.reason.splice(indexCancellation, 1);
                }
                var indexHold = this.reason.findIndex(o => o.text == 'Hold');
                if (-1 !== indexHold) {
                  this.reason.splice(indexHold, 1);
                }
              }
            }
          }
          if (this.selected_action == 'edit_bulk_tickets' && this.ticketShipmentData.length == 0) {

            this.selectedTicketStatusObj = {};
            this.ticketstatus = '';
          }

          if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
            this.isModelLoading = false;
          } else {
            this.isLoading = false;
          }

          // console.log("this.reason=================>",this.reason);
          if (this.selected_action == 'address_change') {
            //   var removeitemsarr=[];
            //   this.reason.forEach(function(reasonid,index){
            //   if(reasonid.text !== 'Address change'){
            //     console.log("index===========>",index);
            //     removeitemsarr.push(index)
            //       this.reason.splice(index, 1);
            //   }
            // });
            let indexstatus = this.reason.findIndex(o => o.text == 'Change status');
            if (-1 !== indexstatus) {
              this.reason.splice(indexstatus, 1);
            }
            var indexcsawHold = this.reason.findIndex(o => o.text == 'CSAW Hold');
            if (-1 !== indexcsawHold) {
              this.reason.splice(indexcsawHold, 1);
            }
            var indexshipStatus = this.reason.findIndex(o => o.text == 'Shipment status');
            if (-1 !== indexshipStatus) {
              this.reason.splice(indexshipStatus, 1);
            }
            var indexPOD = this.reason.findIndex(o => o.text == 'POD related');
            if (-1 !== indexPOD) {
              this.reason.splice(indexPOD, 1);
            }
          }

        } else {
          this.isModelLoading = false;
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }


      }, error => {
        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
          this.isModelLoading = false;
        } else {
          this.isLoading = false;
        }
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTrackingType(subTypeId, businessFlow, type, subReasonId) {

      if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {

        this.isModelLoading = true;
        if (type == 'Edit') {
          this.page = 'trackshipment';
        }
      } else {
        this.isLoading = true;
      }
      let token = 'edw3r323432472748923';

      this.input = ({
        'departmentid': this.DepartmentID,
        'subtypeid': subTypeId,
        'businessFlow': (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
        'page': this.page,
        'type': type,
        'subReasonId': subReasonId,
        'notificationType': '',
        'notificationStatus': '',
        'status': ''
      });

      if (this.selected_action == 'edit_bulk_tickets') {

        this.input.category = '';
        this.input.notificationStatus = '';
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingType',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {

        this.subReason = result.data.data.data;

        if (this.subReason) {

          if (this.$route.params.message) {
            var ticketSummeryListforBulkEdit = this.$route.params.ticketSummeryListforBulkEdit;
            this.selectedSubReasonObj.text = ticketSummeryListforBulkEdit[0].typename;
            this.selectedSubReasonObj.value = ticketSummeryListforBulkEdit[0].subreasonid;
            this.subReasonId = ticketSummeryListforBulkEdit[0].subreasonid;
            this.getTicketAction(this.subReasonId, 'Add');
          }

          let subReasonTempData = [];

          if (this.selected_action != 'edit_bulk_tickets') {

            if (this.selectedBusinessFlowObj.text == 'Forward' || this.selectedBusinessFlowObj.text == 'Reverse') {

              var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
              if (-1 !== indexRedirectBank) {
                this.subReason.splice(indexRedirectBank, 1);
              }
              var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
              if (-1 !== indexSecondaryBank) {
                this.subReason.splice(indexSecondaryBank, 1);
              }
              var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

              if (-1 !== indexPrimaryBank) {
                this.subReason.splice(indexPrimaryBank, 1);
              }

            } else {

              if (this.selected_action == 'address_change') {
                var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
                if (-1 !== indexRedirectBank) {
                  subReasonTempData.push(this.subReason[indexRedirectBank]);
                }
                this.subReason = subReasonTempData;

              } else {

                var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
                if (-1 !== indexSecondaryBank) {
                  subReasonTempData.push(this.subReason[indexSecondaryBank]);
                }

                var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

                if (-1 !== indexPrimaryBank) {
                  subReasonTempData.push(this.subReason[indexPrimaryBank]);
                }

                if (this.selectedReasonObj.value == constantVariable.ARRANGE_DELIVERY || this.selectedReasonObj.value == constantVariable.CANCELLATION_REQUEST || this.selectedReasonObj.value == constantVariable.HOLD_REASON) {
                  this.subReason = this.subReason;
                } else {
                  this.subReason = subReasonTempData;
                }
              }

            }
          }

          if (this.selected_action == 'edit_bulk_tickets' && this.ticketShipmentData.length > 0) {
            if (this.selectedBusinessFlowObj.text == 'Forward' || this.selectedBusinessFlowObj.text == 'Reverse') {

              var indexRtoReattempt = this.subReason.findIndex(o => o.text == 'RTO Reattempt');
              if (-1 !== indexRtoReattempt) {
                this.subReason.splice(indexRtoReattempt, 1);
              }

              var indexDTOReattempt = this.subReason.findIndex(o => o.text == 'DTO Reattempt');
              if (-1 !== indexDTOReattempt) {
                this.subReason.splice(indexDTOReattempt, 1);
              }
            }
          }

          if (this.selected_action == 'edit_bulk_tickets' && this.ticketShipmentData.length == 0 &&
            this.selectedReasonObj.text == 'DTO Change status') {
            var indexPaymeentMode = this.subReason.findIndex(o => o.text == 'Change payment mode / amount');
            if (-1 !== indexPaymeentMode) {
              this.subReason.splice(indexPaymeentMode, 1);
            }
          }

          if (this.selected_action == 'edit_bulk_tickets' && this.ticketShipmentData.length == 0) {

            this.selectedTicketStatusObj = {};
            this.ticketstatus = '';

          }
          if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
            this.isModelLoading = false;
          } else {
            this.isLoading = false;
          }

        } else {
          this.isModelLoading = false;
          this.isLoading = false;
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }


      }, error => {
        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
          this.isModelLoading = false;
        } else {
          this.isLoading = false;
        }
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTicketAction(subReasonId, status) {

      let accessToken;

      if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
        this.isModelLoading = true;
      } else {
        this.isLoading = true;
      }
      let token = 'edw3r323432472748923';

      this.input = ({
        "subReasonId": subReasonId,
        "status": status,
        "page": this.page,
        "departmentId": this.DepartmentID,
        "role": this.userRole
      });
      if (this.selected_action === 'edit_bulk_tickets' && this.Ticketmodal === false) {
        this.input.tab = this.selected_action;
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTicketAction',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        //#bulk b2b_alternate_instruction - Delivery/Pickup Start 
        this.reattemptTimeSlotWithDate='',         
        this.contactNumber='',  
        this.pickupAddress='',
        this.PickupTimeSlotWithDate='',
        //#bulk b2b_alternate_instruction - Delivery/Pickup End
        this.action = result.data.data.data;
        //  console.log( 'message param : '+ this.$route.params.message );

        if (this.action) {

          if (this.$route.params.message !== undefined && this.$route.params.message !== '') {

            var ticketSummeryListforBulkEdit = this.$route.params.ticketSummeryListforBulkEdit;
            if (ticketSummeryListforBulkEdit.length > 1) {
              this.multipleValues = 0;
              for (let i = 0; i < ticketSummeryListforBulkEdit.length; i++) {
                if (ticketSummeryListforBulkEdit[0].action !== ticketSummeryListforBulkEdit[i].action) {
                  this.multipleValues = 1;
                }
              }
              if (this.multipleValues == 0) {
                this.selectedActionObj.text = ticketSummeryListforBulkEdit[0].action;
                this.selectedActionObj.value = ticketSummeryListforBulkEdit[0].actionid;
                this.actionId = ticketSummeryListforBulkEdit[0].actionid;
              } else {
                this.selectedActionObj.text = 'Multiple';
                this.selectedActionObj.value = 'Multiple';
                this.actionId = 'Multiple';
              }
            } else {
              this.selectedActionObj.text = ticketSummeryListforBulkEdit[0].action;
              this.selectedActionObj.value = ticketSummeryListforBulkEdit[0].actionid;
              this.actionId = ticketSummeryListforBulkEdit[0].actionid;
            }
            this.selectedTicketStatus(ticketSummeryListforBulkEdit);
            this.getFilteredTickets(this.$route.params.ticketSummeryListforBulkEdit, this.businessFlowId)
          }


          let flag = false;
          let rvpflag = false;

          var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');
          if (-1 !== indexCsTeam) {
            if (this.selected_action != 'edit_bulk_tickets') {
              if (this.selectedBusinessFlowObj.text == 'Forward' || this.selectedBusinessFlowObj.text == 'Banking Client') {
                this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
              }
              if (this.selectedBusinessFlowObj.text == 'Reverse') {
                this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
              }
            } else {
              if (this.SummarySelectOptionObj.text == 'Forward' || this.SummarySelectOptionObj.text == 'Banking Client') {
                this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
              }
              if (this.SummarySelectOptionObj.text == 'Reverse') {
                this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
              }
            }
          }
          if (this.selected_action != 'edit_bulk_tickets' || this.ticketShipmentData.length > 0) {
            if (this.subDepartmentList) {
              for (var i = 0; i < this.subDepartmentList.length; i++) {
                if (this.selected_action != 'edit_bulk_tickets' && (this.selectedBusinessFlowObj.text == 'Forward' || this.selectedBusinessFlowObj.text == 'Banking Client') && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                  if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                    flag = true;
                    break;
                  }
                } else {
                  if ((this.SummarySelectOptionObj.text == 'Forward' || this.SummarySelectOptionObj.text == 'Banking Client') && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                    if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                      flag = true;
                      break;
                    }
                  }
                }
              }
              for (var i = 0; i < this.subDepartmentList.length; i++) {


                if (this.selected_action != 'edit_bulk_tickets' && this.selectedBusinessFlowObj.text == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
                  if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
                    rvpflag = true;
                    break;
                  }
                } else {
                  if (this.SummarySelectOptionObj.text == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                    if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
                      flag = true;
                      break;
                    }
                  }
                }
              }
            }

            if (this.selectedReasonObj.text !== 'Address change') {

              if ('Admin' !== this.userRole && this.selectedSubReasonObj.text == 'Change Reattempt Date') {
                if (flag == false) {
                  let indexOpsTeam = this.action.findIndex(o => o.text == 'Arranged - Assigned to Ops Team');
                  if (-1 !== indexOpsTeam) {
                    this.action.splice(indexOpsTeam, 1);
                  } else {
                    this.action.push('Assigned to Fwd Client Support Team');
                  }
                } else {
                  let indexFwdCsTeam = this.action.findIndex(o => o.text == 'Assigned to Fwd Client Support Team');
                  if (-1 !== indexFwdCsTeam) {
                    this.action.splice(indexFwdCsTeam, 1);
                  }
                }
              }

              if ('Admin' !== this.userRole && flag == false) {
                var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
                if (-1 !== indexRTONotify) {
                  if (this.selected_action != 'edit_bulk_tickets' && this.selectedBusinessFlowObj.text == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                    this.action.splice(indexRTONotify, 1);
                  } else {
                    if (this.SummarySelectOptionObj.text == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                      this.action.splice(indexRTONotify, 1);
                    }
                  }
                  if (this.selectedBusinessFlowObj.text == 'Reverse') {
                    this.action.splice(indexRTONotify, 1);
                  }
                }
              }

              if ('Admin' !== this.userRole) {
                var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

                if (-1 !== indexPickupCancelled) {

                  if (this.selected_action != 'edit_bulk_tickets' && this.selectedBusinessFlowObj.text == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                    this.action.splice(indexPickupCancelled, 1);
                  } else {
                    if (this.SummarySelectOptionObj.text == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                      this.action.splice(indexPickupCancelled, 1);
                    }
                  }

                  if (this.selectedBusinessFlowObj.text == 'Forward') {
                    this.action.splice(indexPickupCancelled, 1);
                  }
                }
              }
            } else {

              if ('Admin' !== this.userRole) {
                var indexAddressUpdated = this.action.findIndex(o => o.text == 'Address Updated');

                if (-1 !== indexAddressUpdated) {
                  if (this.selected_action != 'edit_bulk_tickets' && (this.selectedBusinessFlowObj.text == 'Forward' || this.selectedBusinessFlowObj.text == 'Banking Client') && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                    this.action.splice(indexAddressUpdated, 1);
                  } else {
                    if ((this.SummarySelectOptionObj.text == 'Forward' || this.SummarySelectOptionObj.text == 'Banking Client') && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                      this.action.splice(indexAddressUpdated, 1);
                    }
                  }

                  if (this.selected_action != 'edit_bulk_tickets' && this.selectedBusinessFlowObj.text == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                    this.action.splice(indexAddressUpdated, 1);
                  } else {
                    if (this.SummarySelectOptionObj.text == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                      this.action.splice(indexAddressUpdated, 1);
                    }
                  }
                }
              }
            }

            if ((this.selected_action == 'edit_bulk_tickets' && this.ticketShipmentData.length == 0) || (this.selected_action != 'edit_bulk_tickets' && (this.selectedSubReasonObj.text == 'Delay in service' || this.selectedReasonObj.text == 'Address change' ||
                this.selectedSubReasonObj.text == 'Misbehavior' || this.selectedSubReasonObj.text == 'Fake update' ||
                this.selectedSubReasonObj.text == 'PDD Crossed' || this.selectedTicketObj.text == 'Request' ||
                this.selectedReasonObj.text == 'Delay in pickup' || this.selectedReasonObj.text == 'Wrong product picked' ||
                this.selectedReasonObj.text == 'Wrong product picked' || this.selectedReasonObj.text == 'Pickup done - Pending for update' ||
                this.selectedReasonObj.text == 'Acknowlegment copy not shared'))) {

              //For handeling information given in bulk update
              if (this.selectedSubReasonObj.text != 'DTO proof of delivery required' && this.selectedSubReasonObj.text != 'RTO proof of delivery required' && this.selectedSubReasonObj.text != 'Mark RTO shipment as Lost/STD' && this.selectedSubReasonObj.text != 'Mark shipment as NTS/Lost/STD' && this.selectedSubReasonObj.text != 'Mark DTO shipment as Lost/STD') {

                var indexAction = this.action.findIndex(o => o.text == 'Information given');
                if (-1 !== indexAction) {
                  this.action.splice(indexAction, 1);
                }
              }
               //#bulk b2b_alternate_instruction - Delivery /Pickup Start
               if ((this.selectedReasonObj.value === constantVariable.Alternate_Instruction_Delivery || this.selectedReasonObj.value === constantVariable.Alternate_Instruction_Pickup )&&
               (this.selectedSubReasonObj.value === constantVariable.Reattempt_Time_Slot_Delivery || this.selectedSubReasonObj.value === constantVariable.Escalation_For_Delivery || this.selectedSubReasonObj.value === constantVariable.Contact_Updated
                || this.selectedSubReasonObj.value === constantVariable.Reattempt_Time_Slot_Pickup || this.selectedSubReasonObj.value === constantVariable.Escalation_For_Pickup || this.selectedSubReasonObj.value === constantVariable.Hold_Pickup || this.selectedSubReasonObj.value === constantVariable.Pickup_Details_Updates || this.selectedSubReasonObj.value === constantVariable.Special_Instruction_Pickup
               ))                
               {                
                if (!this.action.some(a => a.text === 'Information given')) {
                  this.action.push({ text: 'Information given', value: constantVariable.INFORMATION_GIVEN });    
                }
              }
                console.log("After adding Info given:", this.action);
                 //#bulk b2b_alternate_instruction - Delivery/Pickup End
              
            }
          }
          if ((this.selected_action == 'edit_bulk_tickets' || this.ticketShipmentData.length > 0) && ((this.selectedReasonObj.text == 'Arrange delivery' &&
                (this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Urgent delivery')) ||
              this.selectedReasonObj.text == 'Arrange pickup' && (this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup'))) {
            this.editHoldTicket = true;
          }
          this.enableReattemptDate = false;
          this.reAttemptDate = '';
          if (this.selected_action == 'edit_bulk_tickets' && this.ticketShipmentData.length == 1 &&
            this.objTicketSearch.selectedSubReasonObj.text == this.selectedSubReasonObj.text) {

            this.reAttemptDate = this.ticketShipmentData[0].shippingData.reattemptdate;
            this.enableReattemptDate = true;
          }
          if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
            this.isModelLoading = false;
          } else {
            this.isLoading = false;
          }

          //restriction - Information given for manager only case delivered to inscan
          // Delivered to InScan = 72
          if (this.selectedSubReasonObj.text == 'Delivered to InScan') {
            var indexInformationgiven = this.action.findIndex(o => o.text == 'Information given');

            if (-1 !== indexInformationgiven) {
              if (this.userRole == 'Forward CST Agent' || this.userRole == 'Team Leader') {
                this.action.splice(indexInformationgiven, 1);
              }
            }
          }


        } else {
          this.isModelLoading = false;
          this.isLoading = false;
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }

      }, error => {
        if (this.selected_action == 'edit_bulk_tickets' && this.Ticketmodal === true) {
          this.isModelLoading = false;
        } else {
          this.isLoading = false;
        }
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getSearchtags(businessFlow) {

      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';
      const secretKey = constantVariable.enckey;
      const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
      let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
      this.input = ({
        "departmentid": ecDepartmentID,
        'businessFlow': (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
        "page": this.page,
        "tab": this.selected_action
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSearchOption',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.searchOptions = result.data.data.data;
        Object.entries(this.searchOptions).forEach(entry => {
          let i=0;
          entry[1].value = entry[1].id;
          entry[1].text = entry[1].name;
          i++;

        });

        if (businessFlow == 'Banking Client') {
          var indexComplaint = this.searchOptions.findIndex(o => o.text == 'Complaint');
          if (-1 !== indexComplaint) {
            this.searchOptions.splice(indexComplaint, 1);
          }
        }

      }, error => {
        this.isLoading = false;
        this.RaiseTicketDiv = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },

    getSearchResult(id, type, businessFlow) {

      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';

      this.input = ({
        "id": id,
        "type": type,
        "businessFlow": (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
        "page": this.page,
        "tab": this.selected_action,
        "departmentId": this.DepartmentID,
        "role": this.userRole
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSearchResult',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        let flag = false;
        let rvpflag = false;
        //#ebn_enhancement by default show Consignee as source
        this.selectedSourceObj = this.source.find(o => o.value === constantVariable.Source_Consignee);
        this.selectedSourceObj = this.source.find(o => o.text == 'Consignee');
        this.sourceId = constantVariable.Source_Consignee;
        // if (undefined !== result.data.data.data.type_data) {
        //   if (this.selected_action !== '') {
        //     this.selectedSourceObj = {
        //       value: 3,
        //       text: "Client"
        //     };
        //     this.sourceId = 3;
        //   }
        // }

        if (undefined !== result.data.data.data.main_data) {
          this.ticketType = result.data.data.data.main_data;

          if (businessFlow == 'Banking Client' || this.selected_action == 'address_change') {

            var indexTicket = this.ticketType.findIndex(o => o.text == 'Complaint');
            if (-1 !== indexTicket) {
              this.ticketType.splice(indexTicket, 1);
            }
          }
          this.selectedTicketObj = this.ticketType.find(o => o.selected == 1);
          this.ticketTypeId = this.selectedTicketObj.value;
        }

        if (undefined !== result.data.data.data.sub_data) {
          this.reason = result.data.data.data.sub_data;
          this.selectedReasonObj = this.reason.find(o => o.selected == 1);

          if (this.selected_action == 'raise_ticket') {
            if (businessFlow == 'Forward' || businessFlow == 'Reverse') {
              var index = this.reason.findIndex(o => o.text == 'Address change');
              if (-1 !== index) {
                this.reason.splice(index, 1);
              }
            }
          } else if (this.selected_action == 'address_change') {
            // console.log("=====>");
            let indexCancellation = this.reason.findIndex(o => o.text == 'Cancellation Request');
            if (-1 !== indexCancellation) {
              this.reason.splice(indexCancellation, 1);
            }
            let indexArrage = this.reason.findIndex(o => o.text == 'Arrange delivery');
            if (-1 !== indexArrage) {
              this.reason.splice(indexArrage, 1);
            }
            // var indexPOD = this.reason.findIndex(o => o.text == 'POD related');
            // if (-1 !== indexPOD) {
            //     this.reason.splice(indexPOD, 1);
            // }
            let indexstatus = this.reason.findIndex(o => o.text == 'Change status');
            if (-1 !== indexstatus) {
              this.reason.splice(indexstatus, 1);
            }
            var indexcsawHold = this.reason.findIndex(o => o.text == 'CSAW Hold');
            if (-1 !== indexcsawHold) {
              this.reason.splice(indexcsawHold, 1);
            }
            var indexshipStatus = this.reason.findIndex(o => o.text == 'Shipment status');
            if (-1 !== indexshipStatus) {
              this.reason.splice(indexshipStatus, 1);
            }
            var indexPOD = this.reason.findIndex(o => o.text == 'POD related');
            if (-1 !== indexPOD) {
              this.reason.splice(indexPOD, 1);
            }
            let indexArrangepickup = this.reason.findIndex(o => o.text == 'Arrange pickup');
            if (-1 !== indexArrangepickup) {
              this.reason.splice(indexArrangepickup, 1);
            }
          } else {

            if (businessFlow == 'Forward') {
              var indexArrange = this.reason.findIndex(o => o.text == 'Arrange delivery');
              if (-1 !== indexArrange) {
                this.reason.splice(indexArrange, 1);
              }

              var indexCancellation = this.reason.findIndex(o => o.text == 'Cancellation Request');
              if (-1 !== indexCancellation) {
                this.reason.splice(indexCancellation, 1);
              }

              var indexStatus = this.reason.findIndex(o => o.text == 'Change status');
              if (-1 !== indexStatus) {
                this.reason.splice(indexStatus, 1);
              }
            } else if (businessFlow == 'Reverse') {

              var indexArrange = this.reason.findIndex(o => o.text == 'Arrange pickup');
              if (-1 !== indexArrange) {
                this.reason.splice(indexArrange, 1);
              }

              var indexCancellation = this.reason.findIndex(o => o.text == 'Cancellation Request');
              if (-1 !== indexCancellation) {
                this.reason.splice(indexCancellation, 1);
              }
            }
          }
        }
        if (undefined !== result.data.data.data.type_data) {
          this.subReason = result.data.data.data.type_data;
          this.selectedSubReasonObj = this.subReason.find(o => o.selected == 1);
          this.escalation = (undefined != this.selectedSubReasonObj) ? this.selectedSubReasonObj.isescalation : 0;
        }
        if (undefined !== result.data.data.data.action_data) {
          this.action = result.data.data.data.action_data;

          var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');

          if (-1 !== indexCsTeam) {
            if (businessFlow == 'Forward' || businessFlow == 'Banking Client') {
              this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
            } else {
              this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
            }
          }
          if (this.selected_action != 'edit_bulk_tickets') {
            if (this.subDepartmentList) {
              for (var i = 0; i < this.subDepartmentList.length; i++) {
                if ((businessFlow == 'Forward' || businessFlow == 'Banking Client') && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                  if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                    flag = true;
                    break;
                  }
                }
              }
              for (var i = 0; i < this.subDepartmentList.length; i++) {

                if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
                  if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
                    rvpflag = true;
                    break;
                  }
                }
              }
            }
            if ('Admin' !== this.userRole && this.selectedSubReasonObj.text == 'Change Reattempt Date') {
              if (flag == false) {
                let indexOpsTeam = this.action.findIndex(o => o.text == 'Arranged - Assigned to Ops Team');
                if (-1 !== indexOpsTeam) {
                  this.action.splice(indexOpsTeam, 1);
                } else {
                  this.action.push('Assigned to Fwd Client Support Team');
                }
              } else {
                let indexFwdCsTeam = this.action.findIndex(o => o.text == 'Assigned to Fwd Client Support Team');
                if (-1 !== indexFwdCsTeam) {
                  this.action.splice(indexFwdCsTeam, 1);
                }
              }
            }

            if ('Admin' !== this.userRole && flag == false) {
              var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
              if (-1 !== indexRTONotify) {
                if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                  this.action.splice(indexRTONotify, 1);
                }
                if (businessFlow == 'Banking Client' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                  this.action.splice(indexRTONotify, 1);
                }

              }
            }

            if ('Admin' !== this.userRole) {
              var indexStatusChanged = this.action.findIndex(o => o.text == 'Status Changed');

              if (-1 !== indexStatusChanged) {
                if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                  this.action.splice(indexStatusChanged, 1);
                }

                if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                  this.action.splice(indexStatusChanged, 1);
                }
              }
            }

            if ('Admin' !== this.userRole) {

              var indexAddressUpdated = this.action.findIndex(o => o.text == 'Address Updated');

              if (-1 !== indexAddressUpdated) {
                if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                  this.action.splice(indexAddressUpdated, 1);
                }
                if (businessFlow == 'Banking Client' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                  this.action.splice(indexAddressUpdated, 1);
                }
                if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                  this.action.splice(indexAddressUpdated, 1);
                }
              }

              var indexContactUpdated = this.action.findIndex(o => o.text == 'Contact details updated');
              if (-1 !== indexContactUpdated) {
                if (this.SalesDemo.BusinessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                  this.action.splice(indexContactUpdated, 1);
                }

                if (this.SalesDemo.BusinessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                  this.action.splice(indexContactUpdated, 1);
                }
              }
            }

            if ('Admin' !== this.userRole) {
              var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

              if (-1 !== indexPickupCancelled) {

                if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                  this.action.splice(indexPickupCancelled, 1);
                }

              }
            }

            if (this.selectedSubReasonObj.text == 'Delay in service' || this.selectedReasonObj.text == 'Address change' ||
              this.selectedSubReasonObj.text == 'Misbehavior' || this.selectedSubReasonObj.text == 'Fake update' ||
              this.selectedSubReasonObj.text == '"PDD Crossed' || this.selectedTicketObj.text == 'Request' ||
              this.selectedReasonObj.text == 'Delay in pickup' || this.selectedReasonObj.text == 'Wrong product picked' ||
              this.selectedReasonObj.text == 'Wrong product picked' || this.selectedReasonObj.text == 'Pickup done - Pending for update' ||
              this.selectedReasonObj.text == 'Acknowlegment copy not shared') {

              var indexAction = this.action.findIndex(o => o.text == 'Information given');
              if (-1 !== indexAction) {
                this.action.splice(indexAction, 1);
              }
            }
            this.selectedActionObj = {};
          }
        }

        if (undefined !== this.selectedReasonObj) {
          this.reasonId = this.selectedReasonObj.value;
        } else {
          this.reasonId = '';
          this.selectedReasonObj = {};
        }
        if (undefined !== this.selectedSubReasonObj) {
          this.subReasonId = this.selectedSubReasonObj.value;

        } else {
          this.subReasonId = '';
          this.selectedSubReasonObj = {};
        }

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    searchBatch() {
      try {
        if (this.searchDate == null) {
          // date = commonFunction.reformatDateString(this.searchDate.toLocaleDateString());
          this.$alertify.error("Please select  date.");
          return false;
        }
        let date;
        if (this.searchDate !== '') {
          // date = commonFunction.reformatDateString(this.searchDate.toLocaleDateString());
          date = moment(String(this.searchDate)).format('YYYY-MM-DD');
        }
        let date1;
        const d = new Date();
        date1 = moment(String(d)).format('YYYY-MM-DD');
        let dateDiff = moment(date1).diff(date, 'days')

        if (Number(dateDiff) > 7) {
          this.$alertify.error('Please select date in between last 7 days');
          this.batches = [];
          return false;
        }

        let accessToken;
        this.isLoading = true;
        let token = 'edw3r323432472748923';

        this.input = ({
          "date": date,
          "userName": this.username,
          "userRole": this.userRole
        });

        var URL = '';
        if (this.selected_action == 'raise_ticket_tab' || this.selected_action == 'raise_ticket') {
          URL = apiUrl.api_url + 'getSearchB2BBatchesB2B'
        } else {
          URL = apiUrl.api_url + 'getSearchBatches'
        }

        axios({
          method: 'POST',
          // 'url': apiUrl.api_url + 'getSearchBatches',
          // 'url': apiUrl.api_url + 'getSearchBatchessqs',
          'url': URL,
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {

          this.isLoading = false;
          if (result.data.data.status == true) {
            var batches = result.data.data.data;
            this.batches = [];

            if (this.messageBulk == 'raise_ticket_tab' || this.messageBulk == 'raise_ticket') {
              // batches = resultss.result;
              // var batchesCount = resultss.batchresult;
              for (let i = 0; i < batches.length; i++) {
                //**************************************************to handle businessFlow null*******
                if (batches[i].actiondata && batches[i].actiondata.businessflow) {

                } else {
                  batches[i].actiondata = {};
                  batches[i].actiondata.businessflow = null;
                }

                //start//////////////////////////////////////
                let success = 0;
                let fail = 0;
                let totalshipmentcount;
                if (batches[i].batchresult && batches[i].batchresult.length) {
                  batches[i].batchresult.forEach(function (batchC) {
                    // if(batch.id == batchC.batchid){
                    if (batchC == true) {
                      success++;
                    } else {
                      fail++;
                    }
                    // }
                  })
                }
                batches[i].successTotal = success;
                batches[i].failTotal = fail;
                totalshipmentcount = success + fail;
                if (totalshipmentcount >= batches[i].shipmentcount) {
                  batches[i].batchStatus = 'Completed';
                } else {
                  batches[i].batchStatus = 'Processing';
                }
                //end/////////////////////////////////

                if (batches[i].reasonid !== 9) {
                  this.batches.push(batches[i]);
                }



              }
            }
            if (this.messageBulk == 'address_change') {
              this.batches = [];
              // batches = resultss;
              for (let i = 0; i < batches.length; i++) {
                if (batches[i].reasonid == 9) {
                  this.batches.push(batches[i]);
                }
              }
            }

            this.BatchListDiv = true;

            // let totalshipmentcount;

            if (this.batches !== '') {
              // if( this.messageBulk=='address_change') {
              if (this.messageBulk !== 'raise_ticket_tab') {
                //   this.batches.forEach(function (batch) {
                //     let success = 0;
                //     let fail = 0;
                //     batch.batchresult.forEach(function (batchC) {
                //     // if(batch.id == batchC.batchid){
                //       if(batchC == true){
                //                 success++;
                //       }
                //       else{
                //         fail++;
                //        }
                //       // }
                //     })
                //     batch.successTotal = success;
                //     batch.failTotal = fail;
                //     totalshipmentcount = success + fail;
                //     if(totalshipmentcount == batch.shipmentcount){
                //           batch.batchStatus ='Completed';
                //     }
                //     else{
                //       batch.batchStatus ='Processing';
                //     }
                //   })
                // }
                // else{
                // if( this.batches !== '' ) {
                this.batches.forEach(function (batch) {
                  let success = 0;
                  let fail = 0;
                  if (batch.data) {
                    batch.data.forEach(function (data) {
                      if (data.status === true) {
                        success++;
                      } else {
                        fail++;
                      }
                    });
                  }
                  batch.successTotal = success;
                  batch.failTotal = fail;
                });
                // }
              }
            }
          } else {
            this.batches = [];
            this.$alertify.error(result.data.data.msg);
          }

        }, error => {
          this.isLoading = false;
          var commonVariable = commonFunction.showNetworkError(error);
          this.$alertify.error(commonVariable);
        })
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - searchBatch";
        this.$alertify.error(msg);
      }
    },

    saveBulkShipment() {
      try {
        let accessToken;
        let token = 'edw3r323432472748923';
        let strShippingIds = '';
        if (this.selected_action == 'raise_ticket') {
          strShippingIds = this.txtShippingIDs.toString().replace(/^,|,$/g, '');

          if (strShippingIds === '') {
            // Set the variable to true to indicate that the error has been raised
            this.$alertify.error('Please enter shipping ids.');
            
           
            return false;
          }
            //#bulk_appointment shipment limit check on save Forward
          if(this.selectedBusinessFlowObj.value === '1'){
            if (strShippingIds.split(',').length > constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT) {
              this.$alertify.error('Please enter maximum ' + constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT + ' shipping Ids.');
              return false;
            }
          }
          else if(this.selectedBusinessFlowObj.value === '2'){     //#bulk_appointment shipment limit check on save APPOINMENT_DATE
            if (strShippingIds.split(',').length > constantVariable.APPOINMENT_DATE_B2BBULK_LIMIT) {
              this.$alertify.error('Please enter maximum ' + constantVariable.APPOINMENT_DATE_B2BBULK_LIMIT + ' shipping Ids.');
              return false;
            }
          }
          // if ((this.selectedBusinessFlowObj.text == 'Forward' || this.selectedBusinessFlowObj.text == 'Banking Client') && this.ticketTypeId == constantVariable.COMPLAINT) {

          //   if (strShippingIds.split(',').length > constantVariable.FORWARD_COMPLAINT_BULK_LIMIT) {
          //     this.$alertify.error('Please enter maximum ' + constantVariable.FORWARD_COMPLAINT_BULK_LIMIT + ' shipping Ids.');
          //     return false;
          //   }
          // } else if (this.selectedBusinessFlowObj.text == 'Reverse' && this.ticketTypeId == constantVariable.COMPLAINT) {

          //   if (strShippingIds.split(',').length > constantVariable.REVERSE_COMPLAINT_BULK_LIMIT) {
          //     this.$alertify.error('Please enter maximum ' + constantVariable.REVERSE_COMPLAINT_BULK_LIMIT + ' shipping Ids.');
          //     return false;
          //   }
          // } else if ((this.selectedBusinessFlowObj.text == 'Forward' || this.selectedBusinessFlowObj.text == 'Banking Client') && this.ticketTypeId == constantVariable.REQUEST) {

          //   if (strShippingIds.split(',').length > constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT) {
          //     this.$alertify.error('Please enter maximum ' + constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT + ' shipping Ids.');
          //     return false;
          //   }
          //   //rtoh Request validation
          // } else if ((this.selectedBusinessFlowObj.text == 'Forward' && this.rdoB2C === 'B2CHeavies') && this.ticketTypeId == constantVariable.REQUEST) {

          //   if (strShippingIds.split(',').length > constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT) {
          //     this.$alertify.error('Please enter maximum ' + constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT + ' shipping Ids.');
          //     return false;
          //   }   
          // } else if (this.selectedBusinessFlowObj.text == 'Reverse' && this.ticketTypeId == constantVariable.REQUEST) {

          //   if (strShippingIds.split(',').length > constantVariable.REVERSE_REQUEST_BULK_LIMIT) {
          //     this.$alertify.error('Please enter maximum ' + constantVariable.REVERSE_REQUEST_BULK_LIMIT + ' shipping Ids.');
          //     return false;
          //   }
          // } else {
          //   if (strShippingIds.split(',').length > 1000) {
          //     this.$alertify.error('Please enter maximum 1000 shipping Ids.');
          //     return false;
          //   }
          // }
        }

        if (this.sourceId === '') {
          this.$alertify.error('Please select Source.');
          return false;
        }

        if (this.ticketTypeId === '') {
          this.$alertify.error('Please select Tiket Type.');
          return false;

        }

        if (this.reasonId === '') {
          this.$alertify.error('Please select Reason.');
          return false;
        }

        if (this.subReasonId === '') {
          this.$alertify.error('Please select Sub Reason.');
          return false;
        }

        if (this.actionId === '') {
          this.$alertify.error('Please select Action.');
          return false;
        }
        if(this.comments===''){
          this.$alertify.error('Please enter Comment.');
          return false;
        }
        //#bulk_appointment Appoinment date b2b ticket raise 
        if(this.selectedReasonObj.text === 'Arrange delivery' && this.selectedActionObj.value === this.Change_Appointment_Date){
            if(this.selectedBusinessFlowObj.value !== '2'){
              this.$alertify.error('Selected Business Flow should be Forward (Appointment Date)');
              return false;
            }
            if (this.AppointmentDeliveryDate === '') {
              this.$alertify.error('Please select Appointment Delivery Date.');
              return false;
            }
        }else {
            //#bulk_appointment All remaining taggings should be Forward page
          if (this.selectedBusinessFlowObj.value !== '1') {
            this.$alertify.error('Selected Business Flow should be Forward');
            return false;
          }
        }
         //#bulk b2b_alternate_instruction - Delivery /Pickup  Start
            if (
              (this.selectedSubReasonObj.value == constantVariable.Alternate_Instruction_Pickup ||
                this.selectedSubReasonObj.value == constantVariable.Pickup_Details_Updates) &&
              this.selectedActionObj.value == constantVariable.Address_Updated &&
              (!this.pickupAddress || this.pickupAddress.trim().length < 3 || this.pickupAddress.trim().length > 200)
            ) {
              this.$alertify.error('Please enter a valid pick up address. It should not exceed 200 characters.');
              return false;
            }
            if (
                      (this.selectedReasonObj.value == constantVariable.Alternate_Instruction_Delivery || this.selectedReasonObj.value == constantVariable.Alternate_Instruction_Pickup) &&
                      (this.selectedSubReasonObj.value == constantVariable.Reattempt_Time_Slot_Delivery || this.selectedSubReasonObj.value == constantVariable.Reattempt_Time_Slot_Pickup || this.selectedSubReasonObj.value == constantVariable.Hold_Pickup) &&
                      (this.selectedActionObj.value == constantVariable.Attempt_Delivery || this.selectedActionObj.value == constantVariable.Attempt_Pickup ) &&
                        !this.reattemptTimeSlotWithDate )
                      {
                    this.$alertify.error(`Please enter ${this.dynamicTimeSlotLabel}.`);
                      return false;
                    }
            if (
              this.selectedReasonObj.value == constantVariable.Alternate_Instruction_Delivery &&
              this.selectedSubReasonObj.value == constantVariable.Contact_Updated &&
              this.selectedActionObj.value == constantVariable.Updated_Contact &&
              (!this.contactNumber || !/^\d{10}$/.test(this.contactNumber))
            ) {
              this.$alertify.error('Valid 10-digit Contact Number is required.');
              return false;
            }       

            let attempDate = this.reAttemptDate && this.reAttemptDate !== '' 
            ? this.reAttemptDate 
            : this.reattemptTimeSlotWithDate || '';
    
            if (attempDate) {
            attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
            }
      
              let comments = (this.comments != '') ? this.comments : '';
             //#bulk b2b_alternate_instruction - Delivery /Pickup End
      
        if ((this.selectedReasonObj.text == 'Arrange delivery' || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR || this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY ||
            this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON || this.selectedSubReasonObj.value == constantVariable.FAKE_NPR || this.selectedSubReasonObj.value == constantVariable.FAKE_PICKUP ||
            this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_PICKUP) && (this.selectedActionObj.text == 'Arranged - Assigned to Ops Team' || this.selectedActionObj.value==constantVariable.ATTEMPT_DELIVERY )) {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }

        if ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service' && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') ||
          (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update' && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team')) {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }
        if (this.selectedReasonObj.text == 'Arrange pickup' && this.selectedActionObj.text == 'Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }
        if (this.selectedReasonObj.text == 'Arrange pickup' && this.selectedActionObj.text == 'Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }
        if (9 == this.reasonId && this.excelFileUploadPath === '' && this.selectedBusinessFlowObj.text == 'Forward') {
          this.$alertify.error('Please Upload excel for address.');
          return false;
        }
        if (this.selectedReasonObj.text == 'Complaint' && this.selectedSubReasonObj.text == 'Fake update') {
          this.fakeNdrStatus = 1;
        }
        this.AppointmentDeliveryDate= this.dateFormatYYYYMMDD(this.AppointmentDeliveryDate), //#bulk_appointment Appoinment date convert to YYYY-MM-DD
        
        this.input = ({
          shippingIds: strShippingIds,
          sourceId: this.sourceId.toString(),
          ticketTypeId: this.ticketTypeId.toString(),
          reasonId: this.reasonId.toString(),
          subReasonId: this.subReasonId.toString(),
          action: this.actionId.toString(),
          ticketStatusId: this.ticketStatusId.toString(),
          reAttemptDate: attempDate,
          deptid: this.DepartmentID.toString(),
          userId: this.userid,
          username: this.username,
          filename: this.excelFileUploadPath,
          comments: this.comments,
          userType: this.userTypeForTicket,
          IsFakeNDRStatus: this.fakeNdrStatus,
          businessflow: this.businessFlowId ,
          escalation: this.escalation,
          subReason: this.selectedSubReasonObj.text,
          AppointmentDeliveryDate: this.AppointmentDeliveryDate,  // #bulk_appointment AppointmentDeliveryDate save 
           //#bulk b2b_alternate_instruction - Delivery /Pickup Start
           contactNumber: this.contactNumber,
           pickupAddress: this.pickupAddress,
           reattemptTimeSlotWithDate: this.reattemptTimeSlotWithDate || this.pickupHoldTillDate, // #bulk b2b_alternate_instruction - Delivery/Pickup  ---  #fixed reattemptdate date with time 
           //#bulk b2b_alternate_instruction - Delivery /Pickup End
         // rdoB2C: this.rdoB2C
                  });
           //#bulk b2b_alternate_instruction - Delivery /Pickup Start 
           if (attempDate !== '' && attempDate != null) {
            this.input.reAttemptDate = attempDate;
          }


        if (comments !== '' && comments != null) {
          let reattemptDateTimeAndSlot = this.reattemptTimeSlotWithDate
            ? commonFunction.formatDateToCustom(this.reattemptTimeSlotWithDate)
            : '';
         
          if (
            this.reasonId == constantVariable.Alternate_Instruction_Delivery ||
            this.reasonId == constantVariable.Alternate_Instruction_Pickup
          ) {
            
            if (
              (this.subReasonId == constantVariable.Hold_Pickup ||
                this.subReasonId == constantVariable.Reattempt_Time_Slot_Pickup) &&
              this.selectedActionObj.value !== constantVariable.Resolution_Information_Given
            ) {
              this.input.comments = `${this.selectedReasonObj.text} - ${this.selectedSubReasonObj.text} - Updated pickup slot date from {PICKUPHOLD_DATE} to ${reattemptDateTimeAndSlot} - ${comments}`;
            }
            else if (
              this.subReasonId == constantVariable.Reattempt_Time_Slot_Delivery &&
              this.selectedActionObj.value !== constantVariable.Resolution_Information_Given
            ) {
              this.input.comments = `${this.selectedReasonObj.text} - ${this.selectedSubReasonObj.text} - Updated drop slot date from {OLD_REATTEMPT_DATE} to ${reattemptDateTimeAndSlot} - ${comments}`;
            }
         
            else {
              this.input.comments = `${this.selectedReasonObj.text} - ${this.selectedSubReasonObj.text} - ${comments}`;
            }
          } else {
            this.input.comments = `${this.selectedReasonObj.text} - ${this.selectedSubReasonObj.text} - ${comments}`;
          }
        }
         // === B2B CRM ALT Instruction Section Start === -- Added validation condition for input paramters
        if (this.reattemptTimeSlotWithDate !== '' && this.reattemptTimeSlotWithDate !== null) {
          if( this.selectedSubReasonObj.value == constantVariable.Hold_Pickup){
            this.input.pickupHoldTillDate = this.reattemptTimeSlotWithDate;
          }else{
          this.input.reattemptTimeSlotWithDate = this.reattemptTimeSlotWithDate;
          }
        }
        if (this.pickupAddress !== '' && this.pickupAddress !== null) {
          this.input.pickupAddress = this.pickupAddress;
        }
        
        if (this.contactNumber !== '' && this.contactNumber !== null) {
          this.input.contactNumber = this.contactNumber;
        }       
        // #bulk b2b_alternate_instruction - Delivery/Pickup End 

        this.isLoading = true;
        var URL = '';
        if (this.selected_action == 'raise_ticket_tab' || this.selected_action == 'raise_ticket') {
          this.input.rdoB2C=this.rdoB2C;
          URL = apiUrl.api_url + 'createb2bBulkShipmentTicketsSQS'
        } else {
          URL = apiUrl.api_url + 'createBulkShipmentTickets'
        }
        axios({
            method: 'POST',
            // 'url': apiUrl.api_url + 'createBulkShipmentTickets',
            // 'url': apiUrl.api_url + 'createBulkShipmentTicketsSQS',
            'url': URL,
            'data': this.input,
            'min': 1,
            'idle': 10000,
            'acquire': 10000,
            'evict': 120000,
            'handleDisconnects': true,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;

            if (result.data.data.status == true) {

              /*Start IP Tracking */
              let userTrackerObj = {};
              userTrackerObj.subReason = this.selectedSubReasonObj.text;
              if (this.selected_action == 'raise_ticket_tab' || this.selected_action == 'raise_ticket') {
                userTrackerObj.shippingIds = this.input.shippingIds;
              } else {
                userTrackerObj.shippingIds = this.input.filename;
              }
              userTrackerObj.userid = this.userid;
              userTrackerObj.username = this.username;
              userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
              userTrackerObj.projectname = apiUrl.project_name;
              userTrackerObj.trackurl = this.$route.path;
              userTrackerObj.eventTrack = "BulkCreateTicket " + userTrackerObj.subReason;
              authFunction.userTrackerBulkCreate(userTrackerObj);
              /*End IP Tracking */

              this.ticketShipmentData = result.data.data.data;
              this.messageis = result.data.data.msg;
              this.confirmationModal = true;
              // this.$alertify.success(result.data.data.msg);
            } else {
              this.$alertify.error(result.data.data.msg);
            }
            this.resetForm();
            this.searchBatchDiv = true;
            this.RaiseTicketDiv = false;
            //********************************
            // this.searchBatch();

          }, error => {
            this.isLoading = false;
          })
        return false;
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - saveBulkShipment";
        this.$alertify.error(msg);
      }
    },

    confirmationModalFunction() {
      this.confirmationModal = false;
      location.reload();
      // this.searchBatch();
    },

    saveBulkEditShipment() {
      try {

        let token = 'edw3r323432472748923';
        let strShippingIds = '';

        // if (this.sourceId === '') {
        //   this.$alertify.error('Please select Source.');
        //   return false;
        // }

        if (this.ticketTypeId === '') {
          this.$alertify.error('Please select Tiket Type.');
          return false;
        }

        if (this.reasonId === '') {
          this.$alertify.error('Please select Reason.');
          return false;
        }

        if (this.subReasonId === '') {
          this.$alertify.error('Please select Sub Reason.');
          return false;
        }

        if (this.actionId === '') {
          this.$alertify.error('Please select Action.');
          return false;
        }

        let attempDate = (this.reAttemptDate != null && this.reAttemptDate != '') ? this.reAttemptDate : '';

        if (attempDate.length != 10 && attempDate !== '') {
          attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
        }

        if (this.ticketShipmentData.length == 1 && this.selectedReasonObj.text == 'Arrange delivery' && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }

        if (this.ticketShipmentData.length == 1 && ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
            (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }

        if (this.editHoldTicket == false && this.ticketShipmentData.length == 1 && this.selectedReasonObj.text == 'Arrange pickup' && this.selectedActionObj.text == 'Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }
        if (this.editHoldTicket == true && this.selectedReasonObj.text == 'Arrange pickup' && this.selectedActionObj.text == 'Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }

        if (this.selectedReasonObj.text == 'Complaint' && this.selectedSubReasonObj.text == 'Fake update') {
          this.fakeNdrStatus = 1;
        }

        if (this.selectedSubReasonObj.text == 'Change payment mode / amount' && (this.selectedActionObj.text == constantVariable.ASSIGNED_CS_TEAM ||
            this.selectedActionObj.text == constantVariable.STATUS_CHANGED || this.selectedActionObj.value == constantVariable.PAYMENT_DETAILS_CHANGE_REQUESTED)) {

          if (netPayment == '' && orderTypeId == 'CashOnDelivery') {
            this.$alertify.error('Please enter net amount.');
            return false;
          }
        }

        this.input = ({
          ticketIds: this.ticketIDS.toString(),
          ticketData: this.ticketShipmentData,
          sourceId: this.sourceId.toString(),
          ticketTypeId: this.ticketTypeId.toString(),
          reasonId: this.reasonId.toString(),
          subReasonId: this.subReasonId.toString(),
          action: this.actionId.toString(),
          ticketStatusId: this.ticketStatusId.toString(),
          reAttemptDate: attempDate,
          deptid: this.DepartmentID.toString(),
          userId: this.userid,
          username: this.username,
          filename: this.excelFileUploadPath,
          comments: this.comments,
          userType: this.userTypeForTicket,
          IsFakeNDRStatus: this.fakeNdrStatus,
          businessflow: this.SummarySelectOptionObj.text,
          escalation: this.escalation,
          editHoldTicket: this.editHoldTicket
        });

        this.isLoading = true;

        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'createBulkEditTickets',
            'data': JSON.stringify(this.input),
            'min': 1,
            'idle': 10000,
            'acquire': 10000,
            'evict': 60000,
            'handleDisconnects': true,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {


            /*Start IP Tracking */
            let userTrackerObj = {};
            userTrackerObj.subReason = this.selectedSubReasonObj.text;
            userTrackerObj.ticketData = this.input.ticketData;
            userTrackerObj.userid = this.userid;
            userTrackerObj.username = this.username;
            userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
            userTrackerObj.projectname = apiUrl.project_name;
            userTrackerObj.trackurl = this.$route.path;
            userTrackerObj.eventTrack = "BulkUpdateTicket " + userTrackerObj.subReason;
            authFunction.userTrackerBulkEdit(userTrackerObj);
            /*End IP Tracking */





            this.isLoading = false;
            this.ticketResultMsg = '';
            this.ticketResultMsg = result.data.data.msg;
            this.ticketResultModal = true;
            this.allSelected = false;
            this.showList = 0;
            this.shipmentTickets = [];
            this.ticketIDS = [];
            // this.resetFormFilters();
            // this.frmFilterTicket=true;

            this.ticketShipmentData = []
            this.selectAllRecord = false;
            this.Ticketmodal = false;
            this.editHoldTicket = false;

          }, error => {
            this.isLoading = false;
          })
        return false;
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - saveBulkShipment";
        this.$alertify.error(msg);
      }

    },
    // checkPinCodeServiceable
    checkPinCodeServiceable() {
      this.input = ({
        "businessunit": this.SalesDemo.BusinessType,
        "businessflow": this.SalesDemo.BusinessFlow,
        "businessservice": this.SalesDemo.ServiceType, //"Delivery",
        "pincode": this.pincode,
        "routemode": "surface",
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'checkPinCodeServiceable',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        })
        .then(result => {
          let resultDataCrm = result.data.data;

          if (resultDataCrm.status) {
            let response = resultDataCrm.data;
            if (response.code === 200) {
              this.$alertify.success('Pincode is serviceable.');
            } else {
              this.$alertify.error(response.message);
              //this.pincode = '';
              this.validated = true;
            }
          } else {
            this.$alertify.error(response.message);
            // this.pincode = '';
            this.validated = true;
          }
        }, error => {
          this.$alertify.error(error);
        })
    },

    async OnFilterClick(event) {
      try {
        this.pageno = 0;
        this.getShipmentFiltered();
        if (this.listTotalCount > 50) {
          this.$refs.paginate.selected = 0;
        }
      } catch (error) {
        let msg = error + " - OnFilterClick";
        this.$alertify.error(msg);
      }
    },

    getShipmentFiltered() {
      try {
        this.isModelLoading = true;
        var shipmentTicketsFound = [];
        var shipmentTicketsNotFound = [];
        let filter = '';
        filter = this.filter;
        let filterArr = [];
        let filterArray = [];

        if (filter !== '') {
          filterArr = filter.split(',');

          if (filterArr.length > 20) {
            this.$alertify.error("Please select Shipping IDs less than or equal to 20.");
            return false;
          }

        } else {
          this.$alertify.error("Please Enter shipping IDs to search.");
          return false;
        }

        filterArray = filterArr.filter((c, index) => {
          return filterArr.indexOf(c) === index;
        });

        for (let i = 0; i < this.shipmentTickets.length; i++) {
          for (let j = 0; j < filterArray.length; j++) {

            if (filterArray[j] == this.shipmentTickets[i].shippingid) {
              shipmentTicketsFound.push(this.shipmentTickets[i]);
            }
            // if(this.filter[j] !== this.shipmentTickets[i].shippingid){
            //   shipmentTicketsNotFound.push(this.filter[j]);
            // }
          }
        }

        if (shipmentTicketsFound.length > 0) {
          this.listTotalCount = shipmentTicketsFound.length;
          this.shipmentSearchedTickets = this.shipmentTickets;
          this.shipmentTickets = shipmentTicketsFound;
          this.selectAllRecord = true;
          setTimeout(function () {
            this.checkboxDisabledForClosedTickets();
          }.bind(this), 1000);
          this.selectAllCheckbox();
          if (shipmentTicketsFound.length !== filterArray.length) {
            this.$alertify.error("Couldn't search all shipments.");
          }
          this.btnReset = true;
          this.searchDisable = true;

        } else {
          this.$alertify.error("Shipments no found.");
        }


        // if(shipmentTicketsNotFound.length > 0){
        //   // this.listTotalCount = shipmentTicketsNotFound.length;
        //   this.$alertify.error("Some shipping IDs not found : "+ shipmentTicketsNotFound +".");
        // }

        // let projectID = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
        // let accessToken;
        // let token = 'edw3r323432472748923';
        // this.input = ({
        //   'offset': 0,
        //   'limit': 10,
        //   'shippingID': this.filter,
        //   'filterationData' : this.subReasonId
        // });
        //
        // axios({
        //   method: 'POST',
        //   'url': apiUrl.api_url + '	getShipmentDetails',
        //   'data': this.input,
        //   headers: {
        //     'token': token
        //   }
        // }).then(result => {
        //
        //   if (true == result.data.data.status) {
        //       var shipTicketsData = result.data.data.data;
        //       // let shipTicketsLength = shipTicketsData.length;
        //       // var enters = 0;
        //       if(this.enters == 0){
        //         this.shipmentSearchedTickets = this.shipmentTickets;
        //       }
        //       this.shipmentTickets = [];
        //       if(shipTicketsData.length > 0){
        //         this.shipmentTickets = shipTicketsData;
        //         this.enters++;
        //         if (this.shipmentTickets.length > 0) {
        //           var totalRows = this.shipmentTickets[0].full_count;
        //           if (totalRows < 10) {
        //             this.pagecount = 1;
        //             this.pageno = 0;
        //           } else {
        //             this.pagecount = Math.ceil(totalRows / 10)
        //           }
        //         } else {
        //           this.pagecount = 0;
        //         }
        //         setTimeout(function(){this.checkboxDisabledForClosedTickets();}.bind(this), 1000);
        //     }
        //     else{
        //     this.shipmentTickets =  this.shipmentSearchedTickets;
        //     setTimeout(function(){this.checkboxDisabledForClosedTickets();}.bind(this), 1000);
        //     }
        //   }
        //   this.isModelLoading = false;
        //
        // }, error => {
        //   this.isModelLoading = false;
        //   let msg = error;
        //   this.$alertify.error(msg);
        //
        // })

      } catch (error) {
        this.isModelLoading = false;
        this.Ticketmodal = false;
        let msg = error + " - getShipmentTickets";
        this.$alertify.error(msg);
      }
    },

    searchCancelled() {
      this.filter = '';
      this.shipmentTickets = this.shipmentSearchedTickets;
      setTimeout(function () {
        this.checkboxDisabledForClosedTickets();
      }.bind(this), 1000);
      this.btnReset = false;
      this.searchDisable = false;
      this.ticketShipmentData = [];
      this.ticketIDS = [];
      this.listTotalCount = this.shipmentTickets.length;
    },

    //rtoh onCheckRdoB2C
    onCheckRdoB2C() {
   
      //rtoh For Showing Note onCheckRdoB2C
      if (this.rdoB2C === 'B2CEcom') {
        this.bulkShippingIDsMessage = 'NOTE: For B2C Ecom - only '+constantVariable.FORWARD_REQUEST_B2BBULK_LIMIT+' AWB IDs are allowed to be processed at once.';
      } else {
        this.bulkShippingIDsMessage = 'NOTE: For B2C Heavies (MPS) - only '+constantVariable.FORWARD_REQUEST_B2C_HEAVY_BULK_LIMIT+' AWB IDs are allowed to be processed at once, please enter only AWB numbers.';
      }
      // Additional Frreze
      this.TicketDiv = false;
      this.RaiseTicketDiv = false;
         },

    //rtoh getMPSGroupIdwithPartialRTOAllowedData
    getMPSGroupIdwithPartialRTOAllowedData() {
      try { //B2CHeavy
        this.isLoading = true;
        this.B2CHeavy.B2CHeavyArr = [];
     
        let txtShippingIDs = this.txtShippingIDs;
         txtShippingIDs = txtShippingIDs.trim();
        let ShippingIDsArr = txtShippingIDs.split(',');

        this.input = ({
          ShippingIDs: ShippingIDsArr,
        })
        axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'MPSGroupIdwithPartialRTOAllowed',
            'data': this.input,
            headers: commonFunction.getusertoken(),
            })
          .then(async result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                this.B2CHeavy.B2CHeavyArr = resultData.Response;
                this.MPSGroupIdwithPartialRTOAllowedmodal = true

                // By Default Select all Functionality 
                this.isLoadingPagination=true;
                setTimeout(() => {
                  this.B2CHeavy.allSelected=true;
                  this.selectAllB2CHeavyShippingIDOnLoad();
                }, 3000);
                

              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isLoading = false;
        this.MPSGroupIdwithPartialRTOAllowedmodal = false;
        let msg = error + " - getMPSGroupIdwithPartialRTOAllowedData";
        this.$alertify.error(msg);
      }
    },

    // selectB2CHeavyShippingID  selectAllB2CHeavyShippingID 
    // B2CHeavy obj  OtherShipmentShippingIDCheckedArr allSelected B2CHeavyArr  B2CHeavyShipmentData
    selectAllB2CHeavyShippingID: function () {  // B2CHeavyArr
      //console.log("selectAllB2CHeavyShippingID ",this.B2CHeavy.allSelected);
      this.B2CHeavy.OtherShipmentShippingIDCheckedArr = [];
      let ShippingIDEle;
      if (this.B2CHeavy.allSelected) {
        var i = 0;
        for (ShippingIDEle in this.B2CHeavy.B2CHeavyArr) {
//console.log("this.B2CHeavy.B2CHeavyArr[ShippingIDEle].PartialRTOAllowed ",this.B2CHeavy.B2CHeavyArr[ShippingIDEle].PartialRTOAllowed);
          if (this.B2CHeavy.B2CHeavyArr[ShippingIDEle].PartialRTOAllowed==='Yes') {
            this.B2CHeavy.OtherShipmentShippingIDCheckedArr.push(this.B2CHeavy.B2CHeavyArr[ShippingIDEle].ShippingID.toString());
            if (-1 == this.B2CHeavy.B2CHeavyShipmentData.findIndex(o => o.index == ShippingIDEle)) {
              this.B2CHeavy.B2CHeavyShipmentData.push({
                'index': i,
                'shippingData': this.B2CHeavy.B2CHeavyArr[ShippingIDEle]
              });
            }
            i++;
 

          }

       
        }
      } else {
        this.B2CHeavy.OtherShipmentShippingIDCheckedArr = [];
        for (ShippingIDEle in this.B2CHeavy.B2CHeavyArr) {
          if (this.B2CHeavy.B2CHeavyArr[ShippingIDEle].PartialRTOAllowed==='Yes') {
         
          this.B2CHeavy.B2CHeavyShipmentData.splice(this.B2CHeavy.B2CHeavyShipmentData.findIndex(o => o.index == ShippingIDEle), 1);
          }
        }
      }
    },

    selectAllB2CHeavyShippingIDOnLoad: function () {  // B2CHeavyArr
      //console.log("selectAllB2CHeavyShippingID ",this.B2CHeavy.allSelected);
      this.B2CHeavy.OtherShipmentShippingIDCheckedArr = [];
      let ShippingIDEle;
      if (this.B2CHeavy.allSelected) {
        var i = 0;
        for (ShippingIDEle in this.B2CHeavy.B2CHeavyArr) {

            this.B2CHeavy.OtherShipmentShippingIDCheckedArr.push(this.B2CHeavy.B2CHeavyArr[ShippingIDEle].ShippingID.toString());
            if (-1 == this.B2CHeavy.B2CHeavyShipmentData.findIndex(o => o.index == ShippingIDEle)) {
              this.B2CHeavy.B2CHeavyShipmentData.push({
                'index': i,
                'shippingData': this.B2CHeavy.B2CHeavyArr[ShippingIDEle]
              });
            }
            i++;
         }
      } else {
        this.B2CHeavy.OtherShipmentShippingIDCheckedArr = [];
        for (ShippingIDEle in this.B2CHeavy.B2CHeavyArr) {
         
          this.B2CHeavy.B2CHeavyShipmentData.splice(this.B2CHeavy.B2CHeavyShipmentData.findIndex(o => o.index == ShippingIDEle), 1);
        }
      }
      this.isLoadingPagination=false;
    },

    selectB2CHeavyShippingID: function (selectedObj, index, event) {

      this.B2CHeavy.allSelected = false;
      if (event.target.checked) {
        this.B2CHeavy.B2CHeavyShipmentData.push({
          'index': index,
          'shippingData': selectedObj
        });
      } else {
        this.B2CHeavy.B2CHeavyShipmentData.splice(this.B2CHeavy.B2CHeavyShipmentData.findIndex(o => o.index == index), 1);
      }
    },

    ShowB2CHeavyModelDiv(message) {
      try {
       // console.log("ShowB2CHeavyModelDiv ");
this.B2CHeavy.B2CHeavyShipmentData=[];
this.B2CHeavy.OtherShipmentShippingIDCheckedArr=[];
this.B2CHeavy.allSelected=false;

        
          if (this.displayShippingDiv == true) {
            let strShippingIds = this.txtShippingIDs.toString().replace(/^,|,$/g, '');

            if (strShippingIds === '') {
              this.$alertify.error('Please enter Shipping Ids.');
              this.RaiseTicketDiv = false;
              return false;
            } else {
              this.TicketDiv = false;
              this.RaiseTicketDiv = false;
              this.searchBatchDiv = false;
            }

            
            //start  rtoh 1000 / 5000 validation for b2B and B2C  
            let txtShippingIDs = this.txtShippingIDs;
            if (txtShippingIDs != '') {
              let msgAlert=''; 
              txtShippingIDs = txtShippingIDs.trim();
              let ShippingIDsArr = txtShippingIDs.split(',');
              let ArrCnt = ShippingIDsArr.length;
              if (this.businessFlowId === 'Forward' && this.rdoB2C === 'B2CHeavies' && ArrCnt > constantVariable.FORWARD_REQUEST_B2C_HEAVY_BULK_LIMIT) {
                msgAlert = "For B2C Heavies - only "+constantVariable.FORWARD_REQUEST_B2C_HEAVY_BULK_LIMIT+" AWB IDs are allowed to be processed at once";
                this.$alertify.error(msgAlert);
                return false;
              }
              else if (this.businessFlowId === 'Forward' && this.rdoB2C === 'B2CHeavies') {
           this.getMPSGroupIdwithPartialRTOAllowedData();
          //  this.TicketDiv = true;
          //  this.RaiseTicketDiv = true;
          //  this.searchBatchDiv = false;
           return false;
              }



              // else if (this.businessFlowId === 'Forward' && this.rdoB2C === 'B2CEcom' && ArrCnt > 5000) {
              //    msgAlert = "For B2C Ecom - only 5000 AWB IDs are allowed to be processed at once";
              //   this.$alertify.error(msgAlert);
              //   return false;
              // }
            }
            // end 1000 / 5000 validation for b2B and B2C
 

          }
               
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - ShowB2CHeavyModelDiv";
        this.$alertify.error(msg);
      }
    },


    ShowB2CHeavyRaiseTicketDiv(message) {
      try {
 //       console.log("ShowB2CHeavyRaiseTicketDiv this.B2CHeavy.B2CHeavyShipmentData ",this.B2CHeavy.B2CHeavyShipmentData);
   //     console.log("this.B2CHeavy.B2CHeavyShipmentData.length",this.B2CHeavy.B2CHeavyShipmentData.length);
        
        let B2CHeavyShipmentDataLen=(this.B2CHeavy.B2CHeavyShipmentData && this.B2CHeavy.B2CHeavyShipmentData.length)?this.B2CHeavy.B2CHeavyShipmentData.length:0;
         if (B2CHeavyShipmentDataLen==0) {
              this.$alertify.error('Please select atleast one Shipping Id.');
              return false;
            }
            let B2CHeavyShipmentDataArr=this.B2CHeavy.B2CHeavyShipmentData;
         let mappedData=   B2CHeavyShipmentDataArr.map(item => item.shippingData.ShippingID)

         
//console.log("mappedData ",mappedData);
          this.txtShippingIDs=mappedData.join(',');
          this.MPSGroupIdwithPartialRTOAllowedmodal=false;
           this.ShowRaiseTicketDiv( 'raise_ticket' );
           
               
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - ShowB2CHeavyRaiseTicketDiv";
        this.$alertify.error(msg);
      }
    },


    deleteShippingIdByMPSGroupId(MultishipmentGroupid) {
      try {
     //   console.log("ShowB2CHeavyRaiseTicketDiv this.B2CHeavy.B2CHeavyShipmentData ",this.B2CHeavy.B2CHeavyShipmentData);
       // console.log("this.B2CHeavy.B2CHeavyShipmentData.length",this.B2CHeavy.B2CHeavyShipmentData.length);
        
      
    this.confirmMessage = `Are you sure you want to remove all shipments belonging to this MPS - `+MultishipmentGroupid+` from the list for further processing?`;
    this.$alertify.confirmWithTitle('Remove MPS Group ID ', this.confirmMessage, () => this.deleteShippingIdByMPSGroupIdConfirmed(MultishipmentGroupid),
    () => this.$alertify.error("cancel"))
     
               
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - deleteShippingIdByMPSGroupId";
        this.$alertify.error(msg);
      }
    },

    deleteShippingIdByMPSGroupIdConfirmed(MultishipmentGroupid) {
      try {
    this.B2CHeavy.B2CHeavyArr = this.B2CHeavy.B2CHeavyArr.filter(arr => arr.MultishipmentGroupid != MultishipmentGroupid);
    this.B2CHeavy.B2CHeavyShipmentData=this.B2CHeavy.B2CHeavyShipmentData.filter(arr => arr.shippingData.MultishipmentGroupid != MultishipmentGroupid);
              
        //   console.log("this.B2CHeavy.B2CHeavyShipmentData after del",this.B2CHeavy.B2CHeavyShipmentData);
  } catch (error) {
        let msg = error + " - deleteShippingIdByMPSGroupIdConfirmed";
        this.$alertify.error(msg);
      }
    },




  }
}



// WEBPACK FOOTER //
// ./src/views/components/b2b/bulkshipmentaction/bulkshipment.component.js